document.addEventListener('DOMContentLoaded', function () {
  const quizBtn = document.querySelector('.quiz-btn');
  const quizApiSection = document.querySelector('.quiz-api-section');
  const modal = document.getElementById('custom-quiz-popup');
  const klaviyoImage = quizApiSection.getAttribute('klaviyo-image');
  const klaviyoImageMobile = quizApiSection.getAttribute('klaviyo-image-mobile');

  if (!quizBtn || !quizApiSection || !modal) {
    console.error('Quiz elements not found');
    return;
  }

  let isApiCallInProgress = false;
  let currentQuestionData = null;
  let questionHistory = []; // Track questions for navigation
  // Estimated total quiz questions (from API progress); used to compute progress from history length after going back
  let estimatedTotalQuestions = null;

  // Function to save question history to localStorage
  function saveQuestionHistory() {
    try {
      const historyToSave = questionHistory.map(item => ({
        questionData: item.questionData,
        questionId: item.questionId,
        selectedAnswers: item.selectedAnswers
        // Don't save HTML as it can be regenerated
      }));
      localStorage.setItem('quiz_question_history', JSON.stringify(historyToSave));
      
    } catch (error) {
      console.error('Error saving question history to localStorage:', error);
    }
  }

  // Function to load question history from localStorage
  function loadQuestionHistory() {
    try {
      const savedHistory = localStorage.getItem('quiz_question_history');
      if (savedHistory) {
        const parsedHistory = JSON.parse(savedHistory);
        questionHistory = parsedHistory || [];
        return questionHistory;
      }
    } catch (error) {
      console.error('Error loading question history from localStorage:', error);
      questionHistory = [];
    }
    return [];
  }

  // Function to clear question history from localStorage
  function clearQuestionHistory() {
    try {
      localStorage.removeItem('quiz_question_history');
      questionHistory = [];
      estimatedTotalQuestions = null;
    } catch (error) {
      console.error('Error clearing question history:', error);
    }
  }

  // Current question selected answers (for resume after refresh – keep selections visible)
  const CURRENT_QUESTION_STATE_KEY = 'quiz_current_question_state';

  function saveCurrentQuestionState(questionId, selectedAnswerIds) {
    try {
      if (!questionId) return;
      localStorage.setItem(CURRENT_QUESTION_STATE_KEY, JSON.stringify({
        questionId: String(questionId),
        answerIds: Array.isArray(selectedAnswerIds) ? selectedAnswerIds : []
      }));
    } catch (error) {
      console.error('Error saving current question state:', error);
    }
  }

  function loadCurrentQuestionState() {
    try {
      const saved = localStorage.getItem(CURRENT_QUESTION_STATE_KEY);
      if (!saved) return null;
      const parsed = JSON.parse(saved);
      return parsed && typeof parsed.questionId === 'string' ? parsed : null;
    } catch (error) {
      console.error('Error loading current question state:', error);
      return null;
    }
  }

  function clearCurrentQuestionState() {
    try {
      localStorage.removeItem(CURRENT_QUESTION_STATE_KEY);
    } catch (error) {
      console.error('Error clearing current question state:', error);
    }
  }

  // Current question full data (so "Continue Quiz" can restore without API call / re-render)
  const CURRENT_QUESTION_DATA_KEY = 'quiz_current_question_data';

  function saveCurrentQuestionData(data) {
    try {
      if (!data) return;
      localStorage.setItem(CURRENT_QUESTION_DATA_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving current question data:', error);
    }
  }

  function loadCurrentQuestionData() {
    try {
      const saved = localStorage.getItem(CURRENT_QUESTION_DATA_KEY);
      if (!saved) return null;
      return JSON.parse(saved);
    } catch (error) {
      console.error('Error loading current question data:', error);
      return null;
    }
  }

  function clearCurrentQuestionData() {
    try {
      localStorage.removeItem(CURRENT_QUESTION_DATA_KEY);
    } catch (error) {
      console.error('Error clearing current question data:', error);
    }
  }

  // Session token expiry: clear 30 minutes after quiz is completed (user is redirected to product page)
  const QUIZ_COMPLETED_AT_KEY = 'quiz_completed_at';
  const SESSION_EXPIRY_MS = 30 * 60 * 1000; // 30 minutes in milliseconds

  function setQuizCompletedTimestamp() {
    try {
      localStorage.setItem(QUIZ_COMPLETED_AT_KEY, String(Date.now()));
    } catch (error) {
      console.error('Error saving quiz completed timestamp:', error);
    }
  }

  function clearSessionIfExpired() {
    try {
      const completedAt = localStorage.getItem(QUIZ_COMPLETED_AT_KEY);
      if (!completedAt) return;
      const elapsed = Date.now() - Number(completedAt);
      if (elapsed >= SESSION_EXPIRY_MS) {
        localStorage.removeItem('session_token');
        localStorage.removeItem(QUIZ_COMPLETED_AT_KEY);
      }
    } catch (error) {
      console.error('Error checking session expiry:', error);
    }
  }

  // Check if API response indicates quiz is complete (handles multiple possible property names)
  function isQuizCompleteFromResponse(data, hasRecommendations) {
    if (!data) return false;
    if (data.completed === true || data.completed === 'true') return true;
    if (data.data && (data.data.completed === true || data.data.completed === 'true')) return true;
    if (data.quiz_completed === true || data.quiz_completed === 'true') return true;
    if (data.data && (data.data.quiz_completed === true || data.data.quiz_completed === 'true')) return true;
    if (data.status === 'completed' || (data.data && data.data.status === 'completed')) return true;
    if (hasRecommendations) return true; // Showing completion UI = quiz is done
    return false;
  }

  // Function to get shop domain

  // function getShopDomain() {
  //   return window.shopUrl;
  // }


  function getShopDomain() {
    // Static shop domain
    return "miiroko-au.myshopify.com";
  }

  // Function to get shop name only (without .myshopify.com)
  function getShopName(shopDomain) {
    if (!shopDomain) return null;

    // If it contains .myshopify.com, extract just the shop name
    if (shopDomain.includes('.myshopify.com')) {
      return shopDomain.split('.myshopify.com')[0];
    }

    // If it's just a domain, try to extract shop name
    const parts = shopDomain.split('.');
    if (parts.length >= 2 && parts[parts.length - 1] === 'com' && parts[parts.length - 2] === 'myshopify') {
      return parts.slice(0, -2).join('.');
    }

    return shopDomain;
  }

  // Function to escape HTML
  function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Function to show error message in question-error-message element
  function showQuestionError(message) {
    const errorElement = document.querySelector('.question-error-message');
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
    }
  }

  // Function to clear error message
  function clearQuestionError() {
    const errorElement = document.querySelector('.question-error-message');
    if (errorElement) {
      errorElement.textContent = '';
      errorElement.style.display = 'none';
    }
  }

  // Extract progress percentage from API response (for progress bar and for estimating total questions)
  function getProgressPercentageFromData(data) {
    if (!data) return null;
    if (data.progress && data.progress.percentage !== undefined) return Number(data.progress.percentage);
    if (data.data && data.data.progress && data.data.progress.percentage !== undefined) return Number(data.data.progress.percentage);
    if (data.progress !== undefined) return Number(data.progress);
    if (data.data && data.data.progress !== undefined) return Number(data.data.progress);
    if (data.progress_percentage !== undefined) return Number(data.progress_percentage);
    if (data.data && data.data.progress_percentage !== undefined) return Number(data.data.progress_percentage);
    return null;
  }

  // Function to update progress bar (data = API response, optional explicitPercentage overrides when API shape differs)
  function updateProgressBar(data, explicitPercentage) {
    // Use explicit percentage if provided (e.g. when re-applying after going back and re-answering)
    let percentage = explicitPercentage;

    if ((percentage === null || percentage === undefined) && data) {
      percentage = getProgressPercentageFromData(data);
    }

    // Update progress bar if percentage is found (scope to modal so we always hit the quiz bar after refresh)
    if (percentage !== null && percentage !== undefined) {
      const progressBar = (modal && modal.querySelector('.progress-bar .progress')) || document.querySelector('.progress-bar .progress');
      if (progressBar) {
        // Ensure percentage is a number and within valid range (0-100)
        const progressValue = Math.min(100, Math.max(0, Number(percentage)));
        progressBar.style.width = `${progressValue}%`;
      } else {
        console.warn('Progress bar element not found');
      }
    }
  }

  // Function to create popup HTML
  function createPopupHTML(popupTitle, popupContent, buttonText = 'Close', interimContent = '', warningContent = '', popupType = 'single', popupIcons = []) {
    const escapedTitle = escapeHtml(popupTitle || 'Information');
    // Content might contain HTML from the API, so we'll insert it directly
    // The browser will have already decoded it from the data attribute
    const content = popupContent || '';
    const interim = interimContent || '';
    const warning = warningContent || '';
    const escapedButtonText = escapeHtml(buttonText);

    // Determine button class based on button text
    // Use 'quiz-popup-close' for 'Close' and 'quiz-popup-next' for 'OK, next question' or similar
    const isNextButton = buttonText.toLowerCase().includes('next') || buttonText.toLowerCase().includes('ok');
    const buttonClass = isNextButton ? 'quiz-popup-close-btn quiz-popup-next' : 'quiz-popup-close-btn quiz-popup-close';

    // Build content HTML based on popup type
    let contentHTML = '';

    // Normalize popupType to string and trim whitespace
    const normalizedPopupType = String(popupType || 'single').trim().toLowerCase();
  
    // Determine the popup type class for the overlay
    const popupTypeClass = normalizedPopupType === 'icons_text' ? 'question-popup-type-icons_text' : 'question-popup-type-single';

    if (normalizedPopupType === 'icons_text' && Array.isArray(popupIcons) && popupIcons.length > 0) {
      // Render icons_text layout with two columns
      const leftColumn = [];
      const rightColumn = [];

      popupIcons.forEach((icon, index) => {
        const iconTitle = escapeHtml(icon.title || '');
        const iconText = icon.text || '';
        const iconUrl = icon.icon_url || '';

        
        const iconHTML = `
          <div class="popup-icon-item">
            ${iconUrl ? `<div class="popup-icon-circle">
              <img src="${iconUrl}" alt="${iconTitle}" class="popup-icon-image">
            </div>` : ''}
            <div class="right-icon-content">
              <h3 class="popup-icon-title">${iconTitle}</h3>
              <p class="popup-icon-text">${iconText}</p> 
            </div>
          </div>
        `;

        // Split items into two columns (first half in left, second half in right)
        if (index < Math.ceil(popupIcons.length / 2)) {
          leftColumn.push(iconHTML);
        } else {
          rightColumn.push(iconHTML);
        }
      });

      contentHTML = `
        <div class="quiz-popup-icons-container">
          <div class="quiz-popup-icons-column">${leftColumn.join('')}</div>
          <div class="quiz-popup-icons-column">${rightColumn.join('')}</div>
        </div>
      `;
    } else {
      // Default single type layout
      contentHTML = `
        ${interim ? `<div class="quiz-popup-interim">${interim}</div>` : ''}
        ${content ? `<div class="quiz-popup-body">${content}</div>` : ''}
        ${warning ? `<div class="quiz-popup-warning">${warning}</div>` : ''}
      `;
    }

    return `
      <div id="quiz-popup-overlay" class="quiz-popup-overlay ${popupTypeClass}" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 10000; display: flex; align-items: center; justify-content: center;">
        <div class="left-logo-content">
          <img class="mobile-hide" src="//miiroko-au.myshopify.com/cdn/shop/files/miiroko-logo-desktop.png?v=1763120275&amp;width=220">
          
          <img class="desktop-hide" src="//miiroko-au.myshopify.com/cdn/shop/files/Miiroko_logo.png?v=1762842568&amp;width=160">
          
          <button type="button" class="extra-model-close-btn modal__close-btn absolute js-close-modal">
           <svg width="27" height="27" viewBox="0 0 27 27" version="1.1">
  <g id="Design-Layout" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
    <g id="Landing-1280x1080" transform="translate(-26.000000, -43.000000)" stroke="#979797">
      <g id="Group-2" transform="translate(27.000000, 44.000000)">
        <line x1="24.795082" y1="0.204918033" x2="0.204918033" y2="24.795082" id="Line-4"></line>
        <line x1="0.204918033" y1="0.204918033" x2="24.795082" y2="24.795082" id="Line-3"></line>
      </g>
    </g>
  </g>
</svg>
            <span class="visually-hidden">Close</span>
          </button>
        </div>
        <div class="right-form-content">
          <div class="quiz-popup-content">
            <h2 class="quiz-popup-title">${escapedTitle}</h2>
            ${contentHTML}
            <button id="quiz-popup-close-btn" class="${buttonClass}">${escapedButtonText}</button>
          </div>
        </div>
      </div>
    `;
  }

  // Function to show popup
  function showPopup(popupTitle, popupContent, onNext, buttonText = 'Close', interimContent = '', warningContent = '', popupType = 'single', popupIcons = []) {
    // Remove any existing popup first
    const existingPopup = document.getElementById('quiz-popup-overlay');
    if (existingPopup) {
      existingPopup.remove();
    }

    const popupHTML = createPopupHTML(popupTitle, popupContent, buttonText, interimContent, warningContent, popupType, popupIcons);
    document.body.insertAdjacentHTML('beforeend', popupHTML);

    const overlay = document.getElementById('quiz-popup-overlay');
    const closeBtn = document.getElementById('quiz-popup-close-btn');
    const extraCloseBtn = overlay.querySelector('.extra-model-close-btn');
    const popupContentDiv = overlay.querySelector('.quiz-popup-content');

    if (!overlay || !closeBtn) {
      console.error('Popup elements not found after creation');
      return;
    }

    // Add hover effect to close button
    closeBtn.addEventListener('mouseenter', function () {
      this.classList.add('hover');
    });
    closeBtn.addEventListener('mouseleave', function () {
      this.classList.remove('hover');
    });

    closeBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Store reference to overlay before removing
      const overlayToRemove = overlay;

      // Remove overlay immediately and synchronously
      if (overlayToRemove && overlayToRemove.parentNode) {
        overlayToRemove.remove();
      }

      // Also try to remove by ID as a fallback
      const overlayById = document.getElementById('quiz-popup-overlay');
      if (overlayById && overlayById.parentNode) {
        overlayById.remove();
      }

      // Then call the callback if provided
      if (onNext) {
        await onNext();
      }
    });

    // Handle extra-model-close-btn click
    if (extraCloseBtn) {
      extraCloseBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Store reference to overlay before removing
        const overlayToRemove = overlay;

        // Remove overlay immediately and synchronously
        if (overlayToRemove && overlayToRemove.parentNode) {
          overlayToRemove.remove();
        }

        // Also try to remove by ID as a fallback
        const overlayById = document.getElementById('quiz-popup-overlay');
        if (overlayById && overlayById.parentNode) {
          overlayById.remove();
        }

        // Do NOT call onNext callback - just close the popup without proceeding to next question
      });
    }

    // Close on overlay click (but not on popup content click)
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        overlay.remove();
        if (onNext) onNext();
      }
    });

    // Prevent closing when clicking inside the popup content
    if (popupContentDiv) {
      popupContentDiv.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

  }

  // Function to format question HTML based on template_type
  function formatQuestionHTML(data, isLastQuestion = false, isFirstQuestion = false) {

    // Handle different API response structures
    let questionData = data;
    if (data.data && data.data.question) {
      // Structure: { data: { question: {...}, answers: [...] } }
      questionData = { ...data.data.question, answers: data.data.answers || data.data.question.answers || [] };
    } else if (data.data && (data.data.question || data.data.answers)) {
      // Structure: { data: { question: "...", answers: [...] } }
      questionData = data.data;
    }

    const question = questionData.question || questionData.title || '';
    const questionText = questionData.text || '';
    const answers = questionData.answers || [];
    const templateType = questionData.template_type || 'buttons';
    const hasPopup = questionData.has_popup || false;
    const questionId = questionData.id || '';
    const questionType = questionData.question_type || 'single_choice';
    // Use radio buttons for single_choice, checkboxes for multiple_choice
    const inputType = questionType === 'multiple_choice' ? 'checkbox' : 'radio';
    // Default answer to select when question is first shown (from API: default_answer_id)
    const defaultAnswerId = questionData.default_answer_id || (data.data && data.data.default_answer_id) || data.default_answer_id || null;

    // Store popup data for question
    const questionPopupTitle = questionData.popup_title || '';
    const questionPopupContent = questionData.popup_content || '';
    const questionPopupType = questionData.popup_type || 'single';
    const questionPopupIcons = questionData.popup_icons || [];
    const escapedQuestion = escapeHtml(question || 'Question');
    let questionTitleHTML = escapedQuestion;
    let questionTextHtml = questionText;
    // Only show question info icon for non-slider templates
    // For slider templates, the popup button will be shown below the description
    if (hasPopup && templateType !== 'slider') {
      const escapeAttr = (str) => {
        if (!str) return '';
        return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      };
      const escapedPopupTitle = escapeAttr(questionPopupTitle);
      const escapedPopupContent = escapeAttr(questionPopupContent);
      const escapedPopupType = escapeAttr(questionPopupType);
      const escapedPopupIcons = escapeAttr(JSON.stringify(questionPopupIcons));

      questionTitleHTML = `
        <span class="question-title-container">
          <span>${escapedQuestion}</span>
          <span class="question-info-icon" data-question-popup="true" data-popup-title="${escapedPopupTitle}" data-popup-content="${escapedPopupContent}" data-popup-type="${escapedPopupType}" data-popup-icons="${escapedPopupIcons}" title="Click for more information">i</span>
        </span>
      `;
    }

    const escapeAttr = (str) => {
      if (!str) return '';
      return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    };

    let html = `
      <form id="custom-quiz-form" class="quiz-form template-type-${templateType} question-type-${questionType}">
        <div class="form-section active">
          <div class="quiz-content"><h2 class="section-title">${questionTitleHTML}</h2>`
    if (questionType === 'multiple_choice') {
      html += `
            <p class="multiple-choice-instruction">Select all that apply:</p>`
    }
    html += `
          <div class="text quiz-question-text">${questionTextHtml}</div>
          <div class="answers-container">
    `;

    if (templateType === 'file') {
      html += `
        <div class="file-upload-container">
          <input type="file" id="file-upload-${questionId}" name="file_upload_${questionId}" accept="image/*">
          <div id="file-preview-${questionId}" class="file-preview-wrapper">
            <img id="preview-image-${questionId}" src="" alt="Preview">
          </div>
          <div class="file-upload-actions">
            <button type="button" class="btn-remove-photo" id="file-remove-btn-${questionId}" style="display: none;">Remove Photo</button>
            <label for="file-upload-${questionId}" id="file-upload-label-${questionId}" class="btn-change-photo">Upload Photo</label>
            <button type="button" class="btn-file-save" id="file-save-btn-${questionId}" style="display: none;">Save</button>
          </div>
          <div class="skip-button-container" id="skip-container-${questionId}">
            <button type="button" class="btn-skip" id="skipBtn-${questionId}">Skip</button>
          </div>
        </div>
      `;
    } else if (templateType === 'slider' && answers.length > 0) {
      // Use default_answer_id to pick initial answer for preview/description, otherwise first answer
      const initialAnswerIndex = defaultAnswerId != null
        ? answers.findIndex(a => String(a.id || a.value || '') === String(defaultAnswerId))
        : -1;
      const initialAnswer = initialAnswerIndex >= 0 ? answers[initialAnswerIndex] : (answers[0] || {});
      const firstAnswer = initialAnswer;
      const firstAnswerId = firstAnswer.id || firstAnswer.value || '';
      const firstAnswerText = firstAnswer.value || firstAnswer.text || firstAnswer.label || firstAnswer.name || '';
      const firstAnswerNumber = firstAnswer.number || firstAnswer.code || '';
      const firstPreviewImage = firstAnswer.preview_image || firstAnswer.preview || firstAnswer.image || firstAnswer.image_url || '';
      const firstDescription = firstAnswer.description || firstAnswer.desc || '';
      const firstSwatchImage = firstAnswer.thumbnail || firstAnswer.image_url || '';
      const hasMoreThanFiveSlides = answers.length > 5;
      const sliderLayoutClass = hasMoreThanFiveSlides ? 'slider-layout-extended' : 'slider-layout-default';

      if (hasMoreThanFiveSlides) {
        html += `
          <div class="slider-container ${sliderLayoutClass}" id="slider-container-${questionId}" style="width: 100%; max-width: 100%; box-sizing: border-box;">
            <div class="slider-main-content number-of-slide-${answers.length}">
              <div class="slider-left-part">
                <div class="slider-left-image">
                  <div class="slider-preview-image-wrapper">
                    ${firstPreviewImage ? `<img id="slider-preview-image-${questionId}" src="${firstPreviewImage}" alt="${escapeHtml(firstAnswerText)}" class="slider-preview-image">` : `<div class="slider-preview-image-placeholder"></div>`}
                  </div>
                </div>
                <div class="slider-swatches-container">
                ${hasMoreThanFiveSlides ? `
                  <button type="button" class="swiper-button-prev quiz-swatches-prev" id="slider-prev-${questionId}" aria-label="Previous swatches"></button>
                ` : ''}
                  <div class="swiper quiz-swatches-swiper" id="swiper-${questionId}">
                    <div class="swiper-wrapper" style="box-sizing: border-box;">
        `;
      } else {
        html += `
          <div class="slider-container ${sliderLayoutClass}" id="slider-container-${questionId}" style="width: 100%; max-width: 100%; box-sizing: border-box;">
            <div class="slider-main-content number-of-slide-${answers.length}">
              <div class="slider-left-part">
                <div class="slider-left-image">
                  <div class="slider-preview-image-wrapper">
                    ${firstPreviewImage ? `<img id="slider-preview-image-${questionId}" src="${firstPreviewImage}" alt="${escapeHtml(firstAnswerText)}" class="slider-preview-image">` : `<div class="slider-preview-image-placeholder"></div>`}
                  </div>
                </div>
                <div class="slider-swatches-container">
                  <div class="swiper quiz-swatches-swiper" id="swiper-${questionId}">
                    <div class="swiper-wrapper" style="box-sizing: border-box;">
        `;
      }

      answers.forEach((answer, index) => {
        const answerId = answer.id || answer.value || `answer_${index}`;
        const answerText = answer.text || answer.label || answer.name || answer.value || '';
        const answerNumber = answer.number || answer.code || '';
        const answerValue = answer.value || '';
        const answerValueFirstPart = answerValue ? answerValue.split('-')[0].trim() : '';
        const answerValueSecondPart = answerValue ? answerValue.split('-')[1].trim() : '';
        const thumbnail = answer.thumbnail && answer.thumbnail.trim() ? answer.thumbnail : null;
        const imageUrl = answer.image_url && answer.image_url.trim() ? answer.image_url : null;
        const swatchImage = thumbnail || imageUrl || '';
        const previewImage = answer.preview_image || answer.preview || answer.image || answer.image_url || '';
        const description = answer.description || answer.desc || '';
        const isVariation = answer.is_variation === true || answer.is_variation === 'true';
        const variationTitle = answer.variation_title || '';
        const variationDescription = answer.variation_description || '';
        const isFirst = index === 0;
        const isDefaultSelected = defaultAnswerId != null ? String(answerId) === String(defaultAnswerId) : isFirst;
        const inputId = `answer_${questionId}_${answerId}_${index}`;

        html += `
                <div class="swiper-slide">
                  <div class="slider-swatch-wrapper ${isDefaultSelected ? 'selected' : ''}" data-answer-index="${index}" data-answer-id="${answerId}">
                    <input type="${inputType}" id="${inputId}" name="question_${questionId}" value="${answerId}" ${isDefaultSelected ? 'checked' : ''}>
                    <label for="${inputId}" class="slider-swatch-label">
                      <div class="slider-swatch ${isDefaultSelected ? 'selected' : ''}">
                        ${swatchImage ? `<img src="${swatchImage}" alt="${escapeHtml(answerText)}" class="slider-swatch-image">` : '<div class="empty-image"></div>'}
                        ${answerNumber ? `<span class="slider-swatch-number">${escapeHtml(answerNumber)}</span>` : ''}
                        <span class="slider-swatch-text">${escapeHtml(answerValueFirstPart)}</span>
                        </div>
                        <span class="slider-swatch-title">${escapeHtml(answerValueSecondPart)}</span>
                      
                    </label>
                    <div class="slider-answer-data" style="display: none;" 
                         data-preview-image="${previewImage}"
                         data-description="${escapeAttr(description)}"
                         data-number="${escapeAttr(answerNumber)}"
                         data-text="${escapeAttr(answerText)}"
                         data-value-second-part="${escapeAttr(answerValueSecondPart)}"
                         data-is-variation="${isVariation ? 'true' : 'false'}"
                         data-variation-title="${escapeAttr(variationTitle)}"
                         data-variation-description="${escapeAttr(variationDescription)}">
                    </div>
                  </div>
                </div>
        `;
      });

      // Prepare popup button HTML for slider template if hasPopup is true
      // Note: escapeAttr is already defined earlier in the function scope
      const escapedPopupTitle = escapeAttr(questionPopupTitle);
      const escapedPopupContent = escapeAttr(questionPopupContent);
      const escapedPopupType = escapeAttr(questionPopupType);
      const escapedPopupIcons = escapeAttr(JSON.stringify(questionPopupIcons));

      const popupButtonHTML = hasPopup ? `
        <div class="slider-popup-button-container">
          <button type="button" class="slider-popup-button" id="slider-popup-button-${questionId}" 
                  data-question-popup="true" 
                  data-popup-title="${escapedPopupTitle}" 
                  data-popup-content="${escapedPopupContent}" 
                  data-popup-type="${escapedPopupType}" 
                  data-popup-icons="${escapedPopupIcons}">
            <span class="slider-popup-icon">?</span>
            <span class="slider-popup-text">Why can I only see a few shades?</span>
          </button>
        </div>
      ` : '';

      if (hasMoreThanFiveSlides) {
        // Close structure for hasMoreThanFiveSlides layout
        html += `
                    </div>
                    </div>
                    <button type="button" class="swiper-button-next quiz-swatches-next" id="slider-next-${questionId}" aria-label="Next swatches"></button>
                    <div class="active-swatches-text-content hidden"></div>
                </div>
              </div>
              <div class="slider-right-content" id="slider-description-${questionId}">
                <h3 class="title" id="slider-description-title-${questionId}">${escapeHtml(firstAnswerNumber ? firstAnswerNumber + ' - ' : '')}${escapeHtml(firstAnswerText)}</h3>`
        if (firstDescription) {
          html += `
                  <p id="slider-description-text-${questionId}">${firstDescription || ''}</p>`
        }
        html += `
                <div class="slider-variation-content" id="slider-variation-${questionId}" style="display: none;">
                  <h4 class="slider-variation-title h1" id="slider-variation-title-${questionId}"></h4>
                  <p class="slider-variation-description h2" id="slider-variation-description-${questionId}"></p>
                </div>
                ${popupButtonHTML}
              </div>
            </div>
          </div>
        `;
      } else {
        // Close structure - same as hasMoreThanFiveSlides to maintain consistency
        html += `
                    </div>
                  </div>
                  <div class="active-swatches-text-content hidden"></div>
                </div>
              </div>
              <div class="slider-right-content" id="slider-description-${questionId}">
                <h3 class="title" id="slider-description-title-${questionId}">${escapeHtml(firstAnswerNumber ? firstAnswerNumber + ' - ' : '')}${escapeHtml(firstAnswerText)}</h3>`
        if (firstDescription) {
          html += `
                  <p id="slider-description-text-${questionId}">${firstDescription || ''}</p>`
        }
        html += `
                <div class="slider-variation-content" id="slider-variation-${questionId}" style="display: none;">
                  <h4 class="slider-variation-title" id="slider-variation-title-${questionId}"></h4>
                  <p class="slider-variation-description" id="slider-variation-description-${questionId}"></p>
                </div>
                ${popupButtonHTML}
              </div>
            </div>
          </div>
        `;
      }
    } else if (answers.length > 0) {
      answers.forEach((answer, index) => {
        const answerId = answer.id || answer.value || `answer_${index}`;
        const answerText = answer.text || answer.label || answer.name || answer.value || '';
        const answerImage = answer.image || answer.image_url || '';
        const answerValue = answer.value;

        // Check if answer has popup and is enabled
        // Handle both direct properties and nested popup object
        const popupData = answer.popup || {};
        // Check if popup exists - either has_popup flag or popup object exists
        const answerHasPopup = answer.has_popup || popupData.has_popup || (answer.popup && Object.keys(answer.popup).length > 0) || false;

        // Check is_enabled in both locations: answer.is_enabled or answer.popup.is_enabled
        let answerIsEnabled = true; // Default to true if not specified
        if (answer.is_enabled !== undefined) {
          answerIsEnabled = answer.is_enabled;
        } else if (popupData.is_enabled !== undefined) {
          answerIsEnabled = popupData.is_enabled;
        }

        // Get popup content from both locations
        // Handle different field name variations: popup_content, tooltip_content, content
        const answerPopupTitle = answer.popup_title || popupData.popup_title || popupData.title || '';
        const answerPopupContent = answer.popup_content || answer.tooltip_content || popupData.popup_content || popupData.tooltip_content || popupData.content || '';
        const answerInterimContent = answer.interim_content || popupData.interim_content || '';
        const answerWarningContent = answer.warning_content || popupData.warning_content || '';
        const answerPopupType = answer.popup_type || popupData.popup_type || 'single';
        const answerPopupIcons = answer.popup_icons || popupData.popup_icons || [];

        // Skip if no answer text found
        if (!answerText) {
          console.warn(`Skipping answer at index ${index} - no text found:`, answer);
          return;
        }

        // Create unique ID for the input
        const inputId = `answer_${questionId}_${answerId}_${index}`;

        // Add data attributes for popup if answer has popup and is enabled
        // Escape quotes in attributes but preserve HTML structure
        const escapeAttr = (str) => {
          if (!str) return '';
          return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        };
        const shouldShowPopup = answerHasPopup && answerIsEnabled;
        // Store popup_icons as JSON string in data attribute
        const escapedPopupIcons = escapeAttr(JSON.stringify(answerPopupIcons));
        const popupDataAttrs = shouldShowPopup ? `data-answer-popup="true" data-is-enabled="${answerIsEnabled}" data-popup-title="${escapeAttr(answerPopupTitle)}" data-popup-content="${escapeAttr(answerPopupContent)}" data-interim-content="${escapeAttr(answerInterimContent)}" data-warning-content="${escapeAttr(answerWarningContent)}" data-popup-type="${escapeAttr(answerPopupType)}" data-popup-icons="${escapedPopupIcons}"` : '';

        const isDefaultSelected = defaultAnswerId != null && String(answerId) === String(defaultAnswerId);
        html += `<div class="form-group${isDefaultSelected ? ' selected' : ''}" ${popupDataAttrs}>`;

        if (templateType === 'images') {
          // Image template: show image with text label (or empty-image if no image)
          html += `
            <input type="${inputType}" id="${inputId}" name="question_${questionId}" value="${answerId}"${isDefaultSelected ? ' checked' : ''}>
            <label for="${inputId}">
              ${answerImage ? `<img src="${answerImage}" alt="${answerText}">` : '<div class="empty-image"></div>'}
              <span class="text">${answerText}</span>
          </label>
          `;
        } else {
          // Buttons template: show radio buttons
          html += `
            <input type="${inputType}" id="${inputId}" name="question_${questionId}" value="${answerId}"${isDefaultSelected ? ' checked' : ''}>
            <label for="${inputId}">
              <span class="text">${answerText}</span>
            </label>
          `;
        }

        html += `</div>`;
      });
    } else {
      // Show message if no answers
      html += `<p class="no-answers-message">No answers available for this question.</p>`;
      console.warn('No answers to display');
    }

    // Add navigation buttons
    // File template is always the last question
    const isFileTemplate = templateType === 'file';

    // For the first question, it should NEVER be the last question
    // This ensures the Next button always shows on the first question
    // IMPORTANT: Always respect isFirstQuestion parameter - if it's true, force isLastQuestion to false
    // Also check questionHistory length as an additional safeguard
    const isActuallyFirstQuestion = isFirstQuestion === true || isFirstQuestion === 'true' || questionHistory.length === 0;
    let actualIsLastQuestion = false;
    if (isActuallyFirstQuestion) {
      // First question is never the last question - always show Next button
      // Ignore any isLastQuestion value passed in - first question is never last
      actualIsLastQuestion = false;
      
    } else {
      // For subsequent questions, use the isLastQuestion flag or file template
      actualIsLastQuestion = isLastQuestion || isFileTemplate;
    }

    // File template: hide Previous, Next, Submit (use inline Save button instead)
    const showPrevBtn = isFileTemplate ? 'none' : (isActuallyFirstQuestion ? 'none' : 'inline-block');
    const showSubmitBtn = isFileTemplate ? 'none' : (actualIsLastQuestion ? 'inline-block' : 'none');
    // Show Next button for slider templates OR multiple_choice questions, otherwise hide it (auto-proceed will handle navigation)
    const showNextBtn = isFileTemplate ? 'none' : (((templateType === 'slider' || questionType === 'multiple_choice') && !actualIsLastQuestion) ? 'inline-block' : 'none');

    // Debug logging for first question
    
    html += `
      </div>
        </div>
      </div>
      <div class="buttons">
        <span class="question-error-message"></span>
        <button type="button" class="btn-prev" id="prevBtn" style="display: ${showPrevBtn};">Previous Question</button>
        <button type="button" class="btn-next" id="nextBtn" style="display: ${showNextBtn};">Confirm choice</button>
        <button type="submit" class="btn-submit" id="submitBtn" style="display: ${showSubmitBtn};">Submit Quiz</button>
      </div>
      </form>
    `;

    return html;
  }

  // Function to attach event listeners
  function attachEventListeners(questionData) {
    const form = document.getElementById('custom-quiz-form');
    if (!form) {
      console.error('Form not found when attaching event listeners');
      return;
    }

    // Handle different data structures
    let data = questionData;
    if (questionData.data && questionData.data.question) {
      data = { ...questionData.data.question, answers: questionData.data.answers || questionData.data.question.answers || [] };
    } else if (questionData.data && (questionData.data.question || questionData.data.answers)) {
      data = questionData.data;
    }

    const hasPopup = data.has_popup || false;
    const popupTitle = data.popup_title || '';
    const popupContent = data.popup_content || '';
    const questionId = data.id || questionData.id || (questionData.data && questionData.data.id) || '';
    const templateType = data.template_type || questionData.template_type || 'buttons';
    const questionType = data.question_type || questionData.question_type || 'single_choice';

    // Add class to answers-container based on form-group count
    const answersContainer = form.querySelector('.answers-container');
    if (answersContainer) {
      const formGroups = answersContainer.querySelectorAll('.form-group');
      const formGroupCount = formGroups.length;

      // Remove existing classes
      answersContainer.classList.remove('more-form-group', 'less-form-group');

      // Add appropriate class based on count
      if (formGroupCount > 3) {
        answersContainer.closest('.form-section').classList.add('more-form-group');
      } else {
        answersContainer.closest('.form-section').classList.add('less-form-group');
      }

    }

    // Handle file upload template
    if (templateType === 'file') {
      const fileInput = form.querySelector(`#file-upload-${questionId}`);
      const filePreview = form.querySelector(`#file-preview-${questionId}`);
      const previewImage = form.querySelector(`#preview-image-${questionId}`);
      const fileLabel = form.querySelector(`#file-upload-label-${questionId}`);
      const saveBtn = form.querySelector(`#file-save-btn-${questionId}`);
      const removeBtn = form.querySelector(`#file-remove-btn-${questionId}`);
      const skipContainer = form.querySelector(`#skip-container-${questionId}`);
      const skipBtn = form.querySelector(`#skipBtn-${questionId}`);

      // Helper: switch to "image uploaded" state (large preview, Remove Photo, Change Photo, Save; hide Skip)
      function showImageUploadedState() {
        if (filePreview) filePreview.classList.add('visible');
        if (fileLabel) fileLabel.textContent = 'Change Photo';
        if (saveBtn) saveBtn.style.display = 'inline-block';
        if (removeBtn) removeBtn.style.display = 'inline-block';
        if (skipContainer) skipContainer.style.display = 'none';
      }

      // Helper: switch to "no image" state (hide preview, Remove, Save; show Upload Photo + Skip)
      function showNoImageState() {
        if (fileInput) fileInput.value = '';
        if (previewImage) previewImage.src = '';
        if (filePreview) filePreview.classList.remove('visible');
        if (fileLabel) fileLabel.textContent = 'Upload Photo';
        if (saveBtn) saveBtn.style.display = 'none';
        if (removeBtn) removeBtn.style.display = 'none';
        if (skipContainer) skipContainer.style.display = '';
      }

      // Handle file selection and preview (large preview, Remove Photo, Change Photo, Save; hide Skip)
      if (fileInput) {
        fileInput.addEventListener('change', function (e) {
          const file = e.target.files[0];
          if (file) {
            // Validate it's an image
            if (!file.type.startsWith('image/')) {
              alert('Please select an image file.');
              this.value = '';
              return;
            }

            const reader = new FileReader();
            reader.onload = function (e) {
              if (previewImage) previewImage.src = e.target.result;
              showImageUploadedState();
            };
            reader.readAsDataURL(file);
          }
        });
      }

      // Remove Photo button - clear image and return to Upload Photo + Skip
      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          showNoImageState();
        });
      }

      // Skip button - when no image: submit without photo (same as before)
      if (skipBtn) {
        skipBtn.addEventListener('mouseenter', function () {
          this.classList.add('hover');
        });
        skipBtn.addEventListener('mouseleave', function () {
          this.classList.remove('hover');
        });
        skipBtn.addEventListener('click', async function (e) {
          e.preventDefault();
          await submitQuizWithFile(questionId, null, true);
        });
      }

      // Save button - only visible when image uploaded; submits quiz with photo
      if (saveBtn) {
        saveBtn.addEventListener('mouseenter', function () {
          this.classList.add('hover');
        });
        saveBtn.addEventListener('mouseleave', function () {
          this.classList.remove('hover');
        });
        saveBtn.addEventListener('click', async function (e) {
          e.preventDefault();
          const file = fileInput ? fileInput.files[0] : null;
          if (!file) return;
          await submitQuizWithFile(questionId, file, false);
        });
      }
    }

    // Handle slider template
    if (templateType === 'slider') {
      const sliderContainer = form.querySelector(`#slider-container-${questionId}`);
      if (sliderContainer) {
        const previewImage = form.querySelector(`#slider-preview-image-${questionId}`);
        const previewLabel = sliderContainer.querySelector(`.slider-preview-label`);
        const descriptionTitle = form.querySelector(`#slider-description-title-${questionId}`);
        const descriptionText = form.querySelector(`#slider-description-text-${questionId}`);
        const swiperContainer = form.querySelector(`#swiper-${questionId}`);
        const allSwatches = form.querySelectorAll(`.slider-swatch-wrapper`);

        // Handle slider popup button (for slider templates with has_popup)
        const sliderPopupButton = form.querySelector(`#slider-popup-button-${questionId}`);
        if (sliderPopupButton && hasPopup) {
          const sliderHasPopup = sliderPopupButton.getAttribute('data-question-popup') === 'true';
          let sliderPopupTitle = sliderPopupButton.getAttribute('data-popup-title') || '';
          let sliderPopupContent = sliderPopupButton.getAttribute('data-popup-content') || '';
          let sliderPopupType = sliderPopupButton.getAttribute('data-popup-type') || 'single';
          let sliderPopupIconsJson = sliderPopupButton.getAttribute('data-popup-icons') || '[]';
          let sliderPopupIcons = [];

          try {
            if (sliderPopupIconsJson && sliderPopupIconsJson !== '[]' && sliderPopupIconsJson.trim() !== '') {
              sliderPopupIcons = JSON.parse(sliderPopupIconsJson);
            }
          } catch (e) {
            console.error('Failed to parse slider popup_icons JSON:', e);
            sliderPopupIcons = [];
          }

          // Fallback to data if attributes are empty
          if (!sliderPopupTitle && !sliderPopupContent && hasPopup && data) {
            sliderPopupTitle = data.popup_title || '';
            sliderPopupContent = data.popup_content || '';
            const sliderPopupTypeFromData = data.popup_type || data.popupType;
            const sliderPopupIconsFromData = data.popup_icons || data.popupIcons;
            if (sliderPopupTypeFromData && (!sliderPopupType || sliderPopupType === 'single')) {
              sliderPopupType = sliderPopupTypeFromData;
            }
            if (sliderPopupIconsFromData && Array.isArray(sliderPopupIconsFromData) && sliderPopupIconsFromData.length > 0) {
              sliderPopupIcons = sliderPopupIconsFromData;
            }
          }

          const hasSliderPopupContent = sliderPopupTitle || sliderPopupContent;
          const hasSliderIconsContent = sliderPopupType === 'icons_text' && Array.isArray(sliderPopupIcons) && sliderPopupIcons.length > 0;

          if (sliderHasPopup && (hasSliderPopupContent || hasSliderIconsContent)) {
            sliderPopupButton.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              
              // Show popup with the retrieved content
              showPopup(sliderPopupTitle, sliderPopupContent, null, 'Close', '', '', sliderPopupType, sliderPopupIcons);
            });
          }
        }

        // Check if there are more than 5 slides
        const slideCount = allSwatches.length;
        const hasMoreThanFiveSlides = slideCount > 5;
        const isExtendedLayout = sliderContainer.classList.contains('slider-layout-extended');

        // Function to update preview when a swatch is selected
        const updatePreview = (swatchWrapper) => {
          const answerData = swatchWrapper.querySelector('.slider-answer-data');
          if (!answerData) return;

          const previewImageUrl = answerData.getAttribute('data-preview-image') || '';
          const description = answerData.getAttribute('data-description') || '';
          const number = answerData.getAttribute('data-number') || '';
          const text = answerData.getAttribute('data-text') || '';
          const isVariation = answerData.getAttribute('data-is-variation') === 'true';
          const variationTitle = answerData.getAttribute('data-variation-title') || '';
          const variationDescription = answerData.getAttribute('data-variation-description') || '';

          // Update preview image in slider-left-image
          // Find the image wrapper in slider-left-image
          const sliderLeftImage = form.querySelector('.slider-left-image');
          const imageWrapper = sliderLeftImage ? sliderLeftImage.querySelector('.slider-preview-image-wrapper') : null;

          if (imageWrapper) {
            // Check if there's an existing image or placeholder
            let existingImage = imageWrapper.querySelector('.slider-preview-image');
            const existingPlaceholder = imageWrapper.querySelector('.slider-preview-image-placeholder');

            if (previewImageUrl) {
              // If we have an image URL, create/update the image element
              if (existingPlaceholder) {
                // Remove placeholder and create image
                existingPlaceholder.remove();
                existingImage = document.createElement('img');
                existingImage.id = `slider-preview-image-${questionId}`;
                existingImage.className = 'slider-preview-image';
                imageWrapper.appendChild(existingImage);
              } else if (!existingImage) {
                // Create image if it doesn't exist
                existingImage = document.createElement('img');
                existingImage.id = `slider-preview-image-${questionId}`;
                existingImage.className = 'slider-preview-image';
                imageWrapper.appendChild(existingImage);
              }

              if (existingImage) {
                existingImage.src = previewImageUrl;
                existingImage.alt = text;
              }
            } else {
              // If no image URL, show placeholder
              if (existingImage) {
                existingImage.remove();
              }
              if (!existingPlaceholder) {
                const placeholder = document.createElement('div');
                placeholder.className = 'slider-preview-image-placeholder';
                imageWrapper.appendChild(placeholder);
              }
            }
          } else if (previewImage && previewImageUrl) {
            // Fallback to original method if slider-left-image structure not found
            previewImage.src = previewImageUrl;
            previewImage.alt = text;
          }

          // Update preview label (only for default layout)
          if (previewLabel && !isExtendedLayout) {
            previewLabel.textContent = number ? `${number} - ${text}` : text;
          }

          // Update description
          if (descriptionTitle) {
            descriptionTitle.textContent = number ? `${number} - ${text}` : text;
          }
          if (descriptionText) {
            descriptionText.textContent = description;
          }

          // Update variation content (below description) when is_variation is true
          const variationContainer = form.querySelector(`#slider-variation-${questionId}`);
          const variationTitleEl = form.querySelector(`#slider-variation-title-${questionId}`);
          const variationDescEl = form.querySelector(`#slider-variation-description-${questionId}`);
          if (variationContainer && variationTitleEl && variationDescEl) {
            if (isVariation && (variationTitle || variationDescription)) {
              variationTitleEl.textContent = variationTitle;
              variationDescEl.textContent = variationDescription;
              variationContainer.style.display = '';
            } else {
              variationTitleEl.textContent = '';
              variationDescEl.textContent = '';
              variationContainer.style.display = 'none';
            }
          }

          // Update selected state
          allSwatches.forEach(swatch => {
            swatch.classList.remove('selected');
            const swatchElement = swatch.querySelector('.slider-swatch');
            if (swatchElement) {
              swatchElement.classList.remove('selected');
            }
          });
          swatchWrapper.classList.add('selected');
          const swatchElement = swatchWrapper.querySelector('.slider-swatch');
          if (swatchElement) {
            swatchElement.classList.add('selected');
          }
        };

        // Initialize Swiper - declare in outer scope
        let swiperInstance = null;

        // Function to update active swatch text content and position it
        const updateActiveSwatchText = (swatchWrapper) => {
          const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
          if (!activeTextContent) return;

          // If no swatch wrapper provided, find the currently selected one
          if (!swatchWrapper) {
            const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
            if (selectedSwatch) {
              swatchWrapper = selectedSwatch;
            } else {
              // No selected swatch, clear the text
              activeTextContent.textContent = '';
              activeTextContent.style.display = 'none';
              return;
            }
          }

          // Check if this swatch is actually selected/active
          const isSelected = swatchWrapper.classList.contains('selected');
          const input = swatchWrapper.querySelector('input[type="radio"], input[type="checkbox"]');
          const isChecked = input && input.checked;

          // Only update if the swatch is actually selected/checked
          if (!isSelected && !isChecked) {
            // Clear the text if this swatch is not selected
            activeTextContent.textContent = '';
            activeTextContent.style.display = 'none';
            return;
          }

          // Get the text from the active slide
          const swatchText = swatchWrapper.querySelector('.slider-swatch-text');
          const answerData = swatchWrapper.querySelector('.slider-answer-data');
          const answerValueSecondPart = answerData ? (answerData.getAttribute('data-value-second-part') || '') : '';

          if (swatchText) {
            const firstPart = swatchText.textContent || swatchText.innerText || '';
            const fullText = answerValueSecondPart ? `${answerValueSecondPart}`.trim() : firstPart;
            activeTextContent.textContent = fullText;
          } else {
            activeTextContent.textContent = '';
            activeTextContent.style.display = 'none';
            return;
          }

          // Get the slide element
          const swiperSlide = swatchWrapper.closest('.swiper-slide');
          if (!swiperSlide) {
            // If no swiper slide, try to position relative to the swatch wrapper itself
            const swatchRect = swatchWrapper.getBoundingClientRect();
            const containerRect = sliderContainer.querySelector('.slider-swatches-container')?.getBoundingClientRect();
            if (containerRect) {
              const relativeLeft = swatchRect.left - containerRect.left;
              const relativeTop = swatchRect.bottom - containerRect.top;
              const swatchWidth = swatchRect.width;

              // Position centered below the swatch
              activeTextContent.style.left = (relativeLeft + swatchWidth / 2) + 'px';
              activeTextContent.style.top = relativeTop + 'px';
              activeTextContent.style.transform = 'translateX(-50%)';
            }
            return;
          }

          // Calculate position relative to the swiper container
          const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
          if (!swiperWrapper) return;

          const slideRect = swiperSlide.getBoundingClientRect();
          const wrapperRect = swiperWrapper.getBoundingClientRect();
          const containerRect = sliderContainer.querySelector('.slider-swatches-container')?.getBoundingClientRect();

          if (containerRect) {
            // Calculate position relative to the swatches container
            const relativeLeft = slideRect.left - containerRect.left;
            const relativeTop = slideRect.bottom - containerRect.top;
            const slideWidth = slideRect.width;

            // Position centered below the active slide
            activeTextContent.style.left = (relativeLeft + slideWidth / 2) + 'px';
            activeTextContent.style.top = relativeTop + 'px';
            activeTextContent.style.transform = 'translateX(-50%)';
          }
        };

        // Function to set up event listeners after Swiper is initialized
        const setupSwiperEventListeners = () => {
          // Handle swatch clicks and input changes
          allSwatches.forEach(swatchWrapper => {
            const input = swatchWrapper.querySelector('input[type="radio"], input[type="checkbox"]');
            const label = swatchWrapper.querySelector('.slider-swatch-label');

            if (input) {
              input.addEventListener('change', function () {
                if (this.checked) {
                  updatePreview(swatchWrapper);
                  clearQuestionError();

                  // Update active swatch text
                  updateActiveSwatchText(swatchWrapper);

                  // Scroll to selected swatch in Swiper
                  if (swiperInstance && swiperInstance.slideTo) {
                    const swiperSlide = swatchWrapper.closest('.swiper-slide');
                    if (swiperSlide) {
                      const slideIndex = Array.from(swiperSlide.parentElement.children).indexOf(swiperSlide);
                      if (slideIndex !== -1 && slideIndex < swiperInstance.slides.length) {
                        try {
                          swiperInstance.slideTo(slideIndex, 300);
                        } catch (error) {
                          console.warn('Error sliding to swatch:', error);
                        }
                      }
                    }
                  }
                } else {
                  // If unchecked, check if any swatch is still selected
                  const anySelected = sliderContainer.querySelector('.slider-swatch-wrapper.selected, input[type="radio"]:checked, input[type="checkbox"]:checked');
                  if (!anySelected) {
                    // No swatch is selected, clear the text
                    const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
                    if (activeTextContent) {
                      activeTextContent.textContent = '';
                      activeTextContent.style.display = 'none';
                    }
                  } else {
                    // Another swatch is selected, update to that one
                    const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                    if (selectedSwatch) {
                      updateActiveSwatchText(selectedSwatch);
                    }
                  }
                }
              });
            }

            if (label) {
              label.addEventListener('click', function (e) {
                e.preventDefault();
                const input = swatchWrapper.querySelector('input[type="radio"], input[type="checkbox"]');
                if (input) {
                  input.checked = true;
                  input.dispatchEvent(new Event('change'));
                }
              });
            }
          });

          // Initialize with first selected swatch
          const firstSelected = form.querySelector('.slider-swatch-wrapper.selected');
          if (firstSelected) {
            updatePreview(firstSelected);
            // Update active swatch text for initial selection
            setTimeout(() => {
              updateActiveSwatchText(firstSelected);
            }, 100);
          } else {
            // No swatch selected initially, clear the text
            const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
            if (activeTextContent) {
              activeTextContent.textContent = '';
              activeTextContent.style.display = 'none';
            }
          }

          // Update position on window resize
          let resizeTimeout;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
              const selectedSwatch = form.querySelector('.slider-swatch-wrapper.selected');
              if (selectedSwatch) {
                updateActiveSwatchText(selectedSwatch);
              } else {
                // No swatch selected, clear the text
                const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
                if (activeTextContent) {
                  activeTextContent.textContent = '';
                  activeTextContent.style.display = 'none';
                }
              }
            }, 150);
          });
        };

        // Function to initialize Swiper
        const initSwiper = () => {
          // Only initialize Swiper if there are more than 5 slides
          if (!hasMoreThanFiveSlides) {
            setupSwiperEventListeners();
            return;
          }

          if (!swiperContainer) {
            console.error('Swiper container not found');
            setupSwiperEventListeners();
            return;
          }

          // Check if Swiper is already initialized on this container
          if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy(true, true);
          }

          if (typeof Swiper === 'undefined') {
            console.error('Swiper library not found. Make sure swiper-bundle.min.js is loaded.');
            // Set up event listeners even without Swiper
            setupSwiperEventListeners();
            return;
          }

          try {
            const prevButton = sliderContainer.querySelector(`#slider-prev-${questionId}`);
            const nextButton = sliderContainer.querySelector(`#slider-next-${questionId}`);

            if (!prevButton || !nextButton) {
              console.warn('Swiper navigation buttons not found');
            }

            // Find initially selected slide index so the active slider is visible from the start
            const selectedWrapperForInit = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
            let initialSlideIndex = 0;
            if (selectedWrapperForInit) {
              const swiperSlideEl = selectedWrapperForInit.closest('.swiper-slide');
              if (swiperSlideEl && swiperSlideEl.parentElement) {
                const idx = Array.from(swiperSlideEl.parentElement.children).indexOf(swiperSlideEl);
                if (idx >= 0) initialSlideIndex = idx;
              }
            }

            // Define swiperConfig with dynamic selectors based on questionId
            const swiperConfig = {
              initialSlide: initialSlideIndex,
              slidesPerView: 'auto',
              spaceBetween: 15,
              freeMode: false,
              watchOverflow: true,
              autoHeight: false,

              observer: true,
              observeParents: true,
              resizeObserver: true,
              updateOnWindowResize: true,

              roundLengths: true,
              normalizeSlideIndex: true,
              preventInteractionOnTransition: false,

              navigation: prevButton && nextButton ? {
                nextEl: nextButton,
                prevEl: prevButton,
              } : {},

            };

            // Ensure container has width before initialization (but don't set if it's 0, wait for layout)
            const containerWidth = swiperContainer.offsetWidth || swiperContainer.clientWidth;
            const computedWidth = window.getComputedStyle(swiperContainer).width;

            // Only initialize if container has a valid width (not 0 and not extremely large)
            // Also ensure the container is within reasonable bounds (not affecting parent elements)
            if (containerWidth && containerWidth > 0 && containerWidth < 10000) {
              // Additional safeguard: Check if parent elements have been affected
              const quizContent = form.closest('.quiz-content') || form.querySelector('.quiz-content');
              if (quizContent) {
                const parentWidth = quizContent.offsetWidth || quizContent.clientWidth;
                if (parentWidth && parentWidth > 10000) {
                  console.error('Parent element (quiz-content) has invalid width:', parentWidth, '- preventing Swiper initialization');
                  setupSwiperEventListeners(); // Set up listeners without Swiper
                  return;
                }
              }

              swiperInstance = new Swiper(swiperContainer, swiperConfig);

              // Scroll to the initially selected slide so the active slider is visible (e.g. when default_answer_id is last)
              setTimeout(() => {
                const selectedWrapper = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                if (selectedWrapper && swiperInstance && typeof swiperInstance.slideTo === 'function') {
                  const swiperSlide = selectedWrapper.closest('.swiper-slide');
                  if (swiperSlide) {
                    const slideIndex = Array.from(swiperSlide.parentElement.children).indexOf(swiperSlide);
                    if (slideIndex >= 0 && slideIndex < swiperInstance.slides.length) {
                      swiperInstance.slideTo(slideIndex, 0);
                    }
                  }
                }
              }, 50);


              // Add slide change event listener to update active swatch text
              // Only update if the visible slide is actually selected
              swiperInstance.on('slideChange', function () {
                const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
                if (activeSlide) {
                  const swatchWrapper = activeSlide.querySelector('.slider-swatch-wrapper');
                  if (swatchWrapper) {
                    // Check if this swatch is actually selected before updating
                    const isSelected = swatchWrapper.classList.contains('selected');
                    const input = swatchWrapper.querySelector('input[type="radio"], input[type="checkbox"]');
                    const isChecked = input && input.checked;

                    if (isSelected || isChecked) {
                      // Small delay to ensure slide transition is complete
                      setTimeout(() => {
                        updateActiveSwatchText(swatchWrapper);
                      }, 50);
                    } else {
                      // Find the actually selected swatch instead
                      const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                      if (selectedSwatch) {
                        setTimeout(() => {
                          updateActiveSwatchText(selectedSwatch);
                        }, 50);
                      } else {
                        // No swatch selected, clear text
                        const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
                        if (activeTextContent) {
                          activeTextContent.textContent = '';
                          activeTextContent.style.display = 'none';
                        }
                      }
                    }
                  }
                }
              });

              // Also update on transition end for better accuracy
              swiperInstance.on('transitionEnd', function () {
                // Find the actually selected swatch, not just the visible one
                const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                if (selectedSwatch) {
                  updateActiveSwatchText(selectedSwatch);
                } else {
                  // No swatch selected, clear text
                  const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
                  if (activeTextContent) {
                    activeTextContent.textContent = '';
                    activeTextContent.style.display = 'none';
                  }
                }
              });

              // Update active text for initial slide - only if selected
              setTimeout(() => {
                const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                if (selectedSwatch) {
                  updateActiveSwatchText(selectedSwatch);
                }
              }, 100);

              // Set up event listeners after Swiper is initialized
              setupSwiperEventListeners();
            } else {
              console.warn('Container width is invalid:', containerWidth, '- waiting for proper layout');
              // Retry after a short delay
              setTimeout(() => {
                const retryWidth = swiperContainer.offsetWidth || swiperContainer.clientWidth;
                if (retryWidth && retryWidth > 0 && retryWidth < 10000) {
                  swiperInstance = new Swiper(swiperContainer, swiperConfig);

                  // Scroll to the initially selected slide so the active slider is visible
                  setTimeout(() => {
                    const selectedWrapper = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                    if (selectedWrapper && swiperInstance && typeof swiperInstance.slideTo === 'function') {
                      const swiperSlide = selectedWrapper.closest('.swiper-slide');
                      if (swiperSlide) {
                        const slideIndex = Array.from(swiperSlide.parentElement.children).indexOf(swiperSlide);
                        if (slideIndex >= 0 && slideIndex < swiperInstance.slides.length) {
                          swiperInstance.slideTo(slideIndex, 0);
                        }
                      }
                    }
                  }, 50);

                  // Add slide change event listener to update active swatch text
                  // Only update if the visible slide is actually selected
                  swiperInstance.on('slideChange', function () {
                    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
                    if (activeSlide) {
                      const swatchWrapper = activeSlide.querySelector('.slider-swatch-wrapper');
                      if (swatchWrapper) {
                        // Check if this swatch is actually selected before updating
                        const isSelected = swatchWrapper.classList.contains('selected');
                        const input = swatchWrapper.querySelector('input[type="radio"], input[type="checkbox"]');
                        const isChecked = input && input.checked;

                        if (isSelected || isChecked) {
                          setTimeout(() => {
                            updateActiveSwatchText(swatchWrapper);
                          }, 50);
                        } else {
                          // Find the actually selected swatch instead
                          const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                          if (selectedSwatch) {
                            setTimeout(() => {
                              updateActiveSwatchText(selectedSwatch);
                            }, 50);
                          } else {
                            // No swatch selected, clear text
                            const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
                            if (activeTextContent) {
                              activeTextContent.textContent = '';
                              activeTextContent.style.display = 'none';
                            }
                          }
                        }
                      }
                    }
                  });

                  // Also update on transition end for better accuracy
                  swiperInstance.on('transitionEnd', function () {
                    // Find the actually selected swatch, not just the visible one
                    const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                    if (selectedSwatch) {
                      updateActiveSwatchText(selectedSwatch);
                    } else {
                      // No swatch selected, clear text
                      const activeTextContent = sliderContainer.querySelector('.active-swatches-text-content');
                      if (activeTextContent) {
                        activeTextContent.textContent = '';
                        activeTextContent.style.display = 'none';
                      }
                    }
                  });

                  // Update active text for initial slide - only if selected
                  setTimeout(() => {
                    const selectedSwatch = sliderContainer.querySelector('.slider-swatch-wrapper.selected');
                    if (selectedSwatch) {
                      updateActiveSwatchText(selectedSwatch);
                    }
                  }, 100);

                  setupSwiperEventListeners();
                } else {
                  console.error('Container width still invalid after retry:', retryWidth);
                  setupSwiperEventListeners(); // Set up listeners anyway
                }
              }, 200);
            }

            // Set up event listeners after Swiper is initialized
            setupSwiperEventListeners();
          } catch (error) {
            console.error('Error initializing Swiper:', error);
            console.error('Error details:', error.message, error.stack);
            // Set up event listeners even if Swiper fails
            setupSwiperEventListeners();
          }
        };

        // Initialize Swiper after DOM is ready
        const tryInitSwiper = () => {
          // Only initialize Swiper if there are more than 5 slides
          if (!hasMoreThanFiveSlides) {
            setupSwiperEventListeners();
            return false;
          }

          // Check if Swiper is available
          if (typeof Swiper === 'undefined') {
            console.warn('Swiper is not available yet');
            return false;
          }

          // Check if container exists
          if (!swiperContainer) {
            console.warn('Swiper container not found:', `#swiper-${questionId}`);
            return false;
          }

          // Check if container has slides
          const slides = swiperContainer.querySelectorAll('.swiper-slide');
          if (slides.length === 0) {
            console.warn('No slides found in Swiper container');
            return false;
          }

          // Double-check slide count
          if (slides.length <= 5) {
            setupSwiperEventListeners();
            return false;
          }

          // Check if container has width (must be visible and laid out, and not extremely large)
          const containerWidth = swiperContainer.offsetWidth || swiperContainer.clientWidth;
          if (!containerWidth || containerWidth === 0 || containerWidth > 10000) {
            console.warn('Container has invalid width, waiting...', {
              offsetWidth: swiperContainer.offsetWidth,
              clientWidth: swiperContainer.clientWidth,
              computedStyle: window.getComputedStyle(swiperContainer).width
            });
            // Don't set width if it's extremely large - this indicates a problem
            if (containerWidth === 0) {
              swiperContainer.style.width = '100%';
              swiperContainer.style.maxWidth = '100%';
            }
            return false;
          }

          // All checks passed, initialize
          initSwiper();
          return true;
        };

        // If there are 5 or fewer slides, set up event listeners immediately without Swiper
        if (!hasMoreThanFiveSlides) {
          setupSwiperEventListeners();
        } else {
          // Try to initialize immediately if Swiper is available
          if (typeof Swiper !== 'undefined') {
            // Use setTimeout to ensure DOM is fully rendered and laid out
            setTimeout(() => {
              if (!tryInitSwiper()) {
                // Retry a few times if container doesn't have width yet
                let retryCount = 0;
                const retryInit = setInterval(() => {
                  if (tryInitSwiper()) {
                    clearInterval(retryInit);
                  } else {
                    retryCount++;
                    if (retryCount > 20) { // Stop retrying after 2 seconds
                      clearInterval(retryInit);
                      console.warn('Swiper initialization failed after retries, setting up event listeners anyway');
                      setupSwiperEventListeners();
                    }
                  }
                }, 100);
              }
            }, 200);
          } else {
            // Wait for Swiper to load
            let swiperCheckCount = 0;
            const checkSwiper = setInterval(() => {
              if (tryInitSwiper()) {
                clearInterval(checkSwiper);
              } else {
                swiperCheckCount++;
                if (swiperCheckCount > 50) { // Stop checking after 5 seconds
                  clearInterval(checkSwiper);
                  console.warn('Swiper library not loaded after 5 seconds or container not ready');
                  // Set up event listeners even without Swiper
                  setupSwiperEventListeners();
                }
              }
            }, 100);
          }
        }
      }
    }

    // Handle question info icon click (for question popup)
    const questionInfoIcon = form.querySelector('.question-info-icon');
    
    if (questionInfoIcon) {
      const hasQuestionPopup = questionInfoIcon.getAttribute('data-question-popup') === 'true';
      // Get attributes - getAttribute automatically decodes HTML entities
      let questionPopupTitle = questionInfoIcon.getAttribute('data-popup-title') || '';
      let questionPopupContent = questionInfoIcon.getAttribute('data-popup-content') || '';
      let questionPopupType = questionInfoIcon.getAttribute('data-popup-type') || 'single';
      let questionPopupIconsJson = questionInfoIcon.getAttribute('data-popup-icons') || '[]';
      let questionPopupIcons = [];
      try {
        if (questionPopupIconsJson && questionPopupIconsJson !== '[]' && questionPopupIconsJson.trim() !== '') {
          questionPopupIcons = JSON.parse(questionPopupIconsJson);
        }
      } catch (e) {
        console.error('Failed to parse popup_icons JSON:', e, 'JSON string:', questionPopupIconsJson);
        questionPopupIcons = [];
      }

      // If content is empty, try to get from the original data structure as fallback
      if (!questionPopupTitle && !questionPopupContent && hasPopup) {
        questionPopupTitle = popupTitle || '';
        questionPopupContent = popupContent || '';
      }

      // Always try to get popup_type and popup_icons from data if not already set or if empty
      if (hasPopup && data) {
        const questionPopupTypeFromData = data.popup_type || data.popupType;
        const questionPopupIconsFromData = data.popup_icons || data.popupIcons;
        if (questionPopupTypeFromData && (!questionPopupType || questionPopupType === 'single')) {
          questionPopupType = questionPopupTypeFromData;
        }
        if (questionPopupIconsFromData && Array.isArray(questionPopupIconsFromData) && questionPopupIconsFromData.length > 0) {
          questionPopupIcons = questionPopupIconsFromData;
        }
      }

      // Show popup if there's title/content OR if it's icons_text type with icons
      const hasPopupContent = questionPopupTitle || questionPopupContent;
      const hasIconsContent = questionPopupType === 'icons_text' && Array.isArray(questionPopupIcons) && questionPopupIcons.length > 0;

      if (hasQuestionPopup && (hasPopupContent || hasIconsContent)) {
        questionInfoIcon.addEventListener('mouseenter', function () {
          this.classList.add('hover');
        });
        questionInfoIcon.addEventListener('mouseleave', function () {
          this.classList.remove('hover');
        });

        questionInfoIcon.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
     
          // Show popup with the retrieved content
          showPopup(questionPopupTitle, questionPopupContent, null, 'Close', '', '', questionPopupType, questionPopupIcons);
        });
      } else {
        if (!hasQuestionPopup) {
          console.warn('Question info icon found but does not have popup data attribute');
        }
        if (!questionPopupTitle && !questionPopupContent) {
          console.warn('Question popup title and content are both empty');
        }
      }
    } else {
      console.warn('Question info icon not found in form');
      // Try to find it in the section title
      const sectionTitle = form.querySelector('.section-title');
      if (sectionTitle) {
        const iconInTitle = sectionTitle.querySelector('.question-info-icon');
      }
    }

    // Add hover effects to form groups
    const formGroups = form.querySelectorAll('.form-group');
    formGroups.forEach(group => {
      group.addEventListener('mouseenter', function () {
        this.classList.add('hover');
      });
      group.addEventListener('mouseleave', function () {
        const input = this.querySelector('input[type="radio"], input[type="checkbox"]');
        if (!input || !input.checked) {
          this.classList.remove('hover');
        }
      });
    });

    // Handle answer clicks - check if answer has popup and is enabled
    formGroups.forEach(group => {
      const hasAnswerPopup = group.getAttribute('data-answer-popup') === 'true';
      const isEnabledAttr = group.getAttribute('data-is-enabled');
      // Check if is_enabled is true (can be string "true" or boolean true)
      const isEnabled = isEnabledAttr === 'true' || isEnabledAttr === true;

      if (hasAnswerPopup && isEnabled) {
        const answerPopupTitle = group.getAttribute('data-popup-title') || '';
        const answerPopupContent = group.getAttribute('data-popup-content') || '';
        const answerInterimContent = group.getAttribute('data-interim-content') || '';
        const answerWarningContent = group.getAttribute('data-warning-content') || '';
        const answerPopupType = group.getAttribute('data-popup-type') || 'single';
        const answerPopupIconsJson = group.getAttribute('data-popup-icons') || '[]';
        let answerPopupIcons = [];
        try {
          if (answerPopupIconsJson && answerPopupIconsJson !== '[]' && answerPopupIconsJson.trim() !== '') {
            answerPopupIcons = JSON.parse(answerPopupIconsJson);
          }
        } catch (e) {
          console.error('Answer popup - Failed to parse popup_icons JSON:', e, 'JSON string:', answerPopupIconsJson);
          answerPopupIcons = [];
        }
        const label = group.querySelector('label');
        const textSpan = label ? label.querySelector('.text') : null;
        const answerImage = label ? label.querySelector('img') : null;
        const input = group.querySelector('input[type="radio"], input[type="checkbox"]');
        // Function to show the answer popup
        const showAnswerPopup = function (e) {
          if (e) {
            e.stopPropagation();
            e.preventDefault();
          }

          // Create callback to proceed to next question when "OK, next question" is clicked
          const proceedToNextCallback = async function () {
            // Close the popup first - remove it immediately and forcefully
            removePopupOverlay();

            // Ensure the answer is selected before proceeding
            if (input && !input.checked) {
              input.checked = true;
              // Trigger change event to update visual feedback
              input.dispatchEvent(new Event('change'));
            }
            // Small delay to ensure the input is processed and popup is fully removed
            await new Promise(resolve => setTimeout(resolve, 150));
            // Proceed to next question (which will also remove popup as a safeguard)
            await proceedToNextQuestion(questionId);
          };

          // Ensure the answer is selected when popup is shown
          if (input && !input.checked) {
            input.checked = true;
            // Trigger change event to update visual feedback
            input.dispatchEvent(new Event('change'));
          }

          // Determine button text and callback based on content
          let buttonText = 'OK, next question';
          let callback = proceedToNextCallback;

          // For multiple_choice questions, change button to "OK, got it" and only close popup
          if (questionType === 'multiple_choice') {
            buttonText = 'OK, got it';
            callback = function () {
              // Only close the popup, don't proceed to next question
              removePopupOverlay();
              // Ensure the input remains checked when closing
              if (input && !input.checked) {
                input.checked = true;
                // Trigger change event to update visual feedback
                input.dispatchEvent(new Event('change'));
              }
            };
          } else if (answerWarningContent && answerWarningContent.trim()) {
            // If warning_content is present, show "Close" button without proceeding
            // But ensure the input stays checked when closing
            buttonText = 'Close';
            callback = function () {
              // Ensure the input remains checked when closing
              if (input && !input.checked) {
                input.checked = true;
                // Trigger change event to update visual feedback
                input.dispatchEvent(new Event('change'));
              }
            };
          } else if (answerInterimContent && answerInterimContent.trim()) {
            // If interim_content is present, show "Next Question" button with callback
            buttonText = 'OK, next question';
            callback = proceedToNextCallback;
          }

          showPopup(answerPopupTitle, answerPopupContent, callback, buttonText, answerInterimContent, answerWarningContent, answerPopupType, answerPopupIcons);
        };

        // Add click handler to the entire form group, label, text, and image
        // Note: For answers without popups, the change event will handle auto-proceeding
        group.addEventListener('click', function (e) {
          // Don't show popup if clicking directly on the input (let the change event handle it)
          if (e.target.tagName === 'INPUT') {
            return;
          }
          // Only show popup if answer has popup - otherwise let change event handle auto-proceed
          showAnswerPopup(e);
        });

        // Also add click handler to show popup when clicking on text or image
        // Only if answer has popup
        if (textSpan) {
          textSpan.addEventListener('click', showAnswerPopup);
        }

        if (answerImage) {
          answerImage.addEventListener('click', showAnswerPopup);
        }

        if (label) {
          label.addEventListener('click', showAnswerPopup);
        }

        // Add visual indicator
        if (label) {
          label.setAttribute('title', 'Click for more information');
          label.classList.add('pointer');
        }
      }
    });

    // Add visual feedback when answer is selected and handle popups
    const allInputs = form.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    allInputs.forEach(input => {
      input.addEventListener('change', function () {
        // Clear error message when an answer is selected
        clearQuestionError();

        // Persist current question selections so they survive refresh (resume shows them again)
        const currentForm = this.closest('form');
        if (currentForm && questionId) {
          const checked = currentForm.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
          const answerIds = Array.from(checked).map(inp => inp.value);
          saveCurrentQuestionState(questionId, answerIds);
        }

        // Find the parent form group
        const group = this.closest('.form-group');

        // Update all form groups visual feedback
        formGroups.forEach(formGroup => {
          const groupInput = formGroup.querySelector('input[type="radio"], input[type="checkbox"]');
          if (groupInput && groupInput.checked) {
            formGroup.classList.add('selected');
          } else if (groupInput) {
            formGroup.classList.remove('selected');
          }
        });

        // Check if the selected answer has a popup and is enabled
        // Don't show popup if we're restoring answers from history
        const form = this.closest('form');
        const isRestoringAnswers = form && form.getAttribute('data-restoring-answers') === 'true';

        if (group && !isRestoringAnswers && this.checked) {
          const hasAnswerPopup = group.getAttribute('data-answer-popup') === 'true';
          const isEnabledAttr = group.getAttribute('data-is-enabled');
          // Check if is_enabled is true (can be string "true" or boolean true)
          const isEnabled = isEnabledAttr === 'true' || isEnabledAttr === true;

          // Check if popup is already showing (might have been triggered by click handler)
          const existingPopup = document.getElementById('quiz-popup-overlay');

          if (hasAnswerPopup && isEnabled) {
            // Answer has popup - show popup only if not already showing
            if (!existingPopup) {
              const answerPopupTitle = group.getAttribute('data-popup-title') || '';
              const answerPopupContent = group.getAttribute('data-popup-content') || '';
              const answerInterimContent = group.getAttribute('data-interim-content') || '';
              const answerWarningContent = group.getAttribute('data-warning-content') || '';
              const answerPopupType = group.getAttribute('data-popup-type') || 'single';
              const answerPopupIconsJson = group.getAttribute('data-popup-icons') || '[]';
              let answerPopupIcons = [];
              try {
                answerPopupIcons = JSON.parse(answerPopupIconsJson);
              } catch (e) {
                console.warn('Failed to parse popup_icons JSON:', e);
                answerPopupIcons = [];
              }
              // Store reference to the input element (this refers to the input in change event)
              const inputElement = this;

              // Create callback to proceed to next question when "OK, next question" is clicked
              const proceedToNextCallback = async function () {
                // Close the popup first - remove it immediately and forcefully
                removePopupOverlay();

                // Answer is already selected (this is triggered by the change event)
                // Small delay to ensure everything is processed and popup is fully removed
                await new Promise(resolve => setTimeout(resolve, 150));
                // Proceed to next question (which will also remove popup as a safeguard)
                await proceedToNextQuestion(questionId);
              };

              // Determine button text and callback based on content
              let buttonText = 'OK, next question';
              let callback = proceedToNextCallback;

              // For multiple_choice questions, change button to "OK, got it" and only close popup
              if (questionType === 'multiple_choice') {
                buttonText = 'OK, got it';
                callback = function () {
                  // Only close the popup, don't proceed to next question
                  removePopupOverlay();
                  // Ensure the input remains checked when closing
                  if (inputElement && !inputElement.checked) {
                    inputElement.checked = true;
                    // Trigger change event to update visual feedback
                    inputElement.dispatchEvent(new Event('change'));
                  }
                };
              } else if (answerWarningContent && answerWarningContent.trim()) {
                // If warning_content is present, show "Close" button without proceeding
                // But ensure the input stays checked when closing
                buttonText = 'Close';
                callback = function () {
                  // Ensure the input remains checked when closing
                  if (inputElement && !inputElement.checked) {
                    inputElement.checked = true;
                    // Trigger change event to update visual feedback
                    inputElement.dispatchEvent(new Event('change'));
                  }
                };
              } else if (answerInterimContent && answerInterimContent.trim()) {
                // If interim_content is present, show "Next Question" button with callback
                buttonText = 'OK, next question';
                callback = proceedToNextCallback;
              }

              // Show popup when answer is selected
              showPopup(answerPopupTitle, answerPopupContent, callback, buttonText, answerInterimContent, answerWarningContent, answerPopupType, answerPopupIcons);
            } else {
              // Popup already showing (likely triggered by click handler), do nothing
            }
          } else {
            // No popup - automatically proceed to next question after a short delay for visual feedback
            // BUT: Skip auto-proceed for slider templates OR multiple_choice questions (they use Next button)
            if (templateType !== 'slider' && questionType !== 'multiple_choice') {
              setTimeout(async () => {
                // Double-check that the input is still checked (user might have changed selection)
                if (this.checked) {
                  await proceedToNextQuestion(questionId);
                }
              }, 300); // Small delay to allow visual feedback
            }
          }
        }
      });
    });

    // Handle Previous button
    const prevBtn = form.querySelector('.btn-prev');
    if (prevBtn) {
      // Add hover effects
      prevBtn.addEventListener('mouseenter', function () {
        this.classList.add('hover');
      });
      prevBtn.addEventListener('mouseleave', function () {
        this.classList.remove('hover');
      });

      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToPreviousQuestion();
      });
    }

    // Handle Next button
    const nextBtn = form.querySelector('.btn-next');
    if (nextBtn) {
      // Add hover effects
      nextBtn.addEventListener('mouseenter', function () {
        this.classList.add('hover');
      });
      nextBtn.addEventListener('mouseleave', function () {
        this.classList.remove('hover');
      });

      nextBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        await proceedToNextQuestion(questionId);
      });
    }

    // Handle Submit button
    const submitBtn = form.querySelector('.btn-submit');
    if (submitBtn) {
      // Add hover effects
      submitBtn.addEventListener('mouseenter', function () {
        this.classList.add('hover');
      });
      submitBtn.addEventListener('mouseleave', function () {
        this.classList.remove('hover');
      });

      submitBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        // Check if this is a file upload question
        if (templateType === 'file') {
          const fileInput = form.querySelector(`#file-upload-${questionId}`);
          const file = fileInput ? fileInput.files[0] : null;
          // If no file is uploaded, skip the photo upload and submit
          const skipPhoto = !file;
          await submitQuizWithFile(questionId, file, skipPhoto);
        } else {
          await submitQuiz(questionId);
        }
      });
    }
  }

  // Function to go to previous question
  function goToPreviousQuestion() {
    if (questionHistory.length === 0) {
      console.warn('No previous question in history');
      return;
    }

    // Remove any existing popup before going back
    removePopupOverlay();

    // Get the last question from history
    const previousQuestion = questionHistory.pop();
    // Save updated history to localStorage
    saveQuestionHistory();

    // Restore current question data first
    currentQuestionData = previousQuestion.questionData;

    // Determine if this is the first question now
    const isFirstQuestion = questionHistory.length === 0;
    const isLastQuestion = previousQuestion.questionData.is_last || (previousQuestion.questionData.data && previousQuestion.questionData.data.is_last) || false;

    // Re-generate HTML with correct button visibility
    const questionHTML = formatQuestionHTML(previousQuestion.questionData, isLastQuestion, isFirstQuestion);
    quizApiSection.innerHTML = questionHTML;

    saveCurrentQuestionData(previousQuestion.questionData);

    // Re-attach event listeners
    attachEventListeners(previousQuestion.questionData);

    // Explicitly set Previous button visibility: show when there is still history (more questions to go back to)
    const prevBtn = quizApiSection.querySelector('.btn-prev');
    if (prevBtn) {
      prevBtn.style.display = questionHistory.length > 0 ? 'inline-block' : 'none';
    }

    // Do NOT restore selected answers when going back – user sees a blank question to re-answer

    // Current step after going back (question we're now displaying)
    const currentStepAfterBack = questionHistory.length + 1;
    // If we don't have an estimate yet, seed it from this question's progress so the next "proceed" uses local state (avoids jump to stale API progress)
    if ((estimatedTotalQuestions == null || estimatedTotalQuestions < 2) && currentStepAfterBack >= 1) {
      const pct = getProgressPercentageFromData(previousQuestion.questionData);
      if (pct != null && pct > 0 && pct <= 100) {
        const estimated = Math.round((currentStepAfterBack * 100) / pct);
        if (estimated >= 2 && estimated <= 200) estimatedTotalQuestions = estimated;
      }
    }
    // Update progress bar from local state so it matches position after going back
    let backProgressToShow = undefined;
    if (estimatedTotalQuestions != null && estimatedTotalQuestions > 0 && questionHistory.length >= 0) {
      backProgressToShow = Math.min(100, Math.max(0, (currentStepAfterBack / estimatedTotalQuestions) * 100));
    }
    updateProgressBar(previousQuestion.questionData, backProgressToShow);

    // Scroll to top with minimum 120px space when going back (so section-title is visible on mobile)
    requestAnimationFrame(() => {
      const sectionTitle = quizApiSection.querySelector('.section-title');
      const target = sectionTitle || quizApiSection;
      const topOffset = 120;

      function getScrollableParent(el) {
        let parent = el.parentElement;
        while (parent) {
          const style = window.getComputedStyle(parent);
          const overflowY = style.overflowY || style.overflow;
          if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
            return parent;
          }
          parent = parent.parentElement;
        }
        return null;
      }

      const scrollParent = getScrollableParent(target);
      const targetRect = target.getBoundingClientRect();

      if (scrollParent) {
        const parentRect = scrollParent.getBoundingClientRect();
        const newScrollTop = scrollParent.scrollTop + (targetRect.top - parentRect.top) - topOffset;
        scrollParent.scrollTo({ top: Math.max(0, newScrollTop), behavior: 'smooth' });
      } else {
        const newScrollY = targetRect.top + (window.scrollY || window.pageYOffset) - topOffset;
        window.scrollTo({ top: Math.max(0, newScrollY), behavior: 'smooth' });
      }
    });
  }

  // Function to remove popup overlay if it exists
  function removePopupOverlay() {
    const overlay = document.getElementById('quiz-popup-overlay');
    if (overlay) {
      overlay.remove();
    }
    // Double check - remove any remaining popup elements
    const remainingPopups = document.querySelectorAll('#quiz-popup-overlay, .quiz-popup-overlay');
    remainingPopups.forEach(popup => {
      if (popup && popup.parentNode) {
        popup.remove();
      }
    });
  }

  // Function to proceed to next question
  async function proceedToNextQuestion(questionId) {
    // Ensure any popup is removed before proceeding
    removePopupOverlay();

    if (isApiCallInProgress) {
      return;
    }

    const form = document.getElementById('custom-quiz-form');
    if (!form) {
      console.error('Quiz form not found');
      return;
    }

    // Get selected answers
    const checkedInputs = form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

    if (checkedInputs.length === 0) {
      showQuestionError('Please select at least one answer before proceeding.');
      return;
    }

    // Clear any existing error message since we have a valid selection
    clearQuestionError();

    const answerIds = Array.from(checkedInputs).map(input => input.value);

    // Get session token from localStorage
    const sessionToken = localStorage.getItem('session_token');

    if (!sessionToken) {
      console.error('No session token found in localStorage');
      alert('Session expired. Please restart the quiz.');
      return;
    }

    // If questionId is not provided, try to get it from the form
    if (!questionId) {
      // Try to get from current question data
      if (currentQuestionData) {
        questionId = currentQuestionData.id || (currentQuestionData.data && currentQuestionData.data.id);
      }
      // Or try to get from the first input's name attribute
      if (!questionId && checkedInputs.length > 0) {
        const inputName = checkedInputs[0].name;
        questionId = inputName.replace('question_', '');
      }
    }

    // Store current question in history before moving forward
    if (currentQuestionData) {
      const form = document.getElementById('custom-quiz-form');
      const checkedInputs = form ? form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked') : [];
      const selectedAnswers = Array.from(checkedInputs).map(input => input.value);

      // Clear current-question state so next question starts fresh (saved again when user selects)
      clearCurrentQuestionState();

      questionHistory.push({
        questionData: currentQuestionData,
        questionId: questionId,
        selectedAnswers: selectedAnswers,
        html: quizApiSection.innerHTML
      });
      // Save to localStorage
      saveQuestionHistory();
    }

    isApiCallInProgress = true;

    try {
      // Ensure popup is removed before showing loading state
      removePopupOverlay();

      // Show loading state
      quizApiSection.innerHTML = '<div class="dot-loader"></div>';

      const apiUrl = 'https://quiz.miiroko.com/api/v1/quiz/start';
      const shopDomain = getShopDomain();

      // Create FormData with required fields
      const formData = new FormData();
      formData.append('session_token', sessionToken);
      formData.append('question_id', questionId);
      formData.append('shop', shopDomain);
      answerIds.forEach(id => {
        formData.append('answer_ids[]', id);
      });

      // Log what we're sending

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
        mode: 'cors',
        credentials: 'omit'
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => 'Unknown error');
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();

      // Keep estimated total questions from API progress; don't overwrite with a smaller value (stale API after going back)
      const apiPercentage = getProgressPercentageFromData(data);
      if (apiPercentage != null && apiPercentage > 0 && apiPercentage <= 100 && questionHistory.length >= 0) {
        const currentStep = questionHistory.length + 1;
        const estimated = Math.round((currentStep * 100) / apiPercentage);
        if (estimated >= 2 && estimated <= 200) {
          const keepExisting = estimatedTotalQuestions != null && estimatedTotalQuestions > 0 && estimated < estimatedTotalQuestions;
          if (!keepExisting) {
            estimatedTotalQuestions = estimated;
          }
        }
      }

      // Use progress from local state (history length) when we have an estimate, so going back and re-answering shows correct progress
      let progressToShow = undefined;
      if (estimatedTotalQuestions != null && estimatedTotalQuestions > 0 && questionHistory.length >= 0) {
        const currentStep = questionHistory.length + 1;
        progressToShow = Math.min(100, Math.max(0, (currentStep / estimatedTotalQuestions) * 100));
      }
      updateProgressBar(data, progressToShow);

      // Update session token if provided (check multiple locations)
      const newSessionToken = data.session_token || (data.data && data.data.session_token);
      if (newSessionToken) {
        localStorage.setItem('session_token', newSessionToken);
      }

      // Check for recommendations in various possible locations (before deciding if complete)
      let recommendations = null;
      if (data.recommendations) {
        recommendations = data.recommendations;
      } else if (data.data && data.data.recommendations) {
        recommendations = data.data.recommendations;
      } else if (data.products) {
        recommendations = data.products;
      } else if (data.data && data.data.products) {
        recommendations = data.data.products;
      } else if (data.result) {
        recommendations = data.result;
      } else if (data.data && data.data.result) {
        recommendations = data.data.result;
      }
      const hasRecommendations = recommendations && (Array.isArray(recommendations) ? recommendations.length > 0 : true);

      // Quiz is complete when API says so OR when we have recommendations (completion UI)
      if (isQuizCompleteFromResponse(data, hasRecommendations)) {
        // Clear question history and current question state/data when quiz is completed
        clearQuestionHistory();
        clearCurrentQuestionState();
        clearCurrentQuestionData();
        setQuizCompletedTimestamp(); // Session token will be cleared 30 min after this

        // Redirect to product page with result param (contact form is on product page)
        if (recommendations) {
          redirectToProductWithResult(recommendations, data);
        } else {
          quizApiSection.innerHTML = `
            <div class="error-message">
              <strong>No product recommendation available.</strong> Please try again.
              <br><br>
              <button onclick="location.reload()">Retry</button>
            </div>
          `;
        }
      } else {
        // Display next question
        currentQuestionData = data;
        const isLastQuestion = data.is_last || (data.data && data.data.is_last) || false;
        const isFirstQuestion = questionHistory.length === 0;
        const questionHTML = formatQuestionHTML(data, isLastQuestion, isFirstQuestion);
        quizApiSection.innerHTML = questionHTML;
        saveCurrentQuestionData(data);
        attachEventListeners(data);
        // Re-apply progress bar after DOM update (use same local progress so it stays correct after going back and re-answering)
        requestAnimationFrame(function () {
          updateProgressBar(data, progressToShow);
        });
      }

    } catch (error) {
      console.error('Error getting next question:', error);
      quizApiSection.innerHTML = `
        <div class="error-message">
          <strong>Error loading next question:</strong><br>
          ${error.message}
          <br><br>
          <button onclick="location.reload()">Retry</button>
        </div>
      `;
    } finally {
      isApiCallInProgress = false;
    }
  }

  // Function to handle contact form submission
  function attachContactFormHandler(productUrls) {
    const contactForm = document.getElementById('quiz-contact-form');
    if (!contactForm) {
      console.warn('Contact form not found');
      return;
    }

    contactForm.addEventListener('submit', async function (e) {
      e.preventDefault();

      const nameInput = document.getElementById('quiz-name');
      const emailInput = document.getElementById('quiz-email');
      const errorMessage = document.getElementById('quiz-form-error');
      const submitBtn = contactForm.querySelector('.quiz-form-submit-btn');

      // Clear previous errors
      if (errorMessage) {
        errorMessage.style.display = 'none';
        errorMessage.textContent = '';
      }

      // Get form values
      const name = nameInput ? nameInput.value.trim() : '';
      const email = emailInput ? emailInput.value.trim() : '';

      // Validate form
      if (!name) {
        if (errorMessage) {
          errorMessage.textContent = 'Please enter your name.';
          errorMessage.style.display = 'block';
        }
        if (nameInput) nameInput.focus();
        return;
      }

      if (!email) {
        if (errorMessage) {
          errorMessage.textContent = 'Please enter your email address.';
          errorMessage.style.display = 'block';
        }
        if (emailInput) emailInput.focus();
        return;
      }

      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        if (errorMessage) {
          errorMessage.textContent = 'Please enter a valid email address.';
          errorMessage.style.display = 'block';
        }
        if (emailInput) emailInput.focus();
        return;
      }

      // Disable submit button during submission
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      try {
        // Get session token
        const sessionToken = localStorage.getItem('session_token');
        const shopDomain = getShopDomain();

        if (!sessionToken) {
          if (errorMessage) {
            errorMessage.textContent = 'Session expired. Please restart the quiz.';
            errorMessage.style.display = 'block';
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'See My Results';
          }
          return;
        }

        // Send form data to API
        const apiUrl = 'https://quiz.miiroko.com/api/v1/quiz/start';
        const formData = new FormData();
        formData.append('session_token', sessionToken);
        formData.append('name', name);
        formData.append('email', email);
        formData.append('shop', shopDomain);
        const response = await fetch(apiUrl, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
          },
          mode: 'cors',
          credentials: 'omit'
        });

        if (!response.ok) {
          const errorText = await response.text().catch(() => 'Unknown error');
          console.error('API error response:', errorText);
          throw new Error(`Failed to submit form: ${response.status}`);
        }

        const responseData = await response.json();

        // Update session token if provided
        const newSessionToken = responseData.session_token || (responseData.data && responseData.data.session_token);
        if (newSessionToken) {
          localStorage.setItem('session_token', newSessionToken);
        }

        // Get the session token to use for the result parameter (use updated token if available, otherwise use original)
        const tokenForResult = newSessionToken || sessionToken;

        // Redirect to the first product URL
        if (productUrls && productUrls.length > 0) {
          // Use the first product URL
          const redirectUrl = productUrls[0];

          // Ensure URL is absolute
          let finalUrl = redirectUrl;
          if (!redirectUrl.startsWith('http://') && !redirectUrl.startsWith('https://')) {
            // If it's a relative URL, make it absolute
            if (redirectUrl.startsWith('/')) {
              finalUrl = window.location.origin + redirectUrl;
            } else {
              // If it's a handle (no slashes), construct the product URL
              // Remove any leading/trailing slashes and ensure it starts with /products/
              const cleanHandle = redirectUrl.replace(/^\/+|\/+$/g, '');
              if (cleanHandle && !cleanHandle.includes('/')) {
                finalUrl = window.location.origin + '/products/' + cleanHandle;
              } else {
                // If it already contains path structure, just prepend origin
                finalUrl = window.location.origin + '/' + cleanHandle;
              }
            }
          }

          // Add result parameter with session_token to the URL
          const urlObj = new URL(finalUrl);
          urlObj.searchParams.set('result', tokenForResult);
          finalUrl = urlObj.toString();

          // Redirect to product page
          window.location.href = finalUrl;
        } else {
          // If no product URL, show error
          if (errorMessage) {
            errorMessage.textContent = 'No product recommendation available. Please try again.';
            errorMessage.style.display = 'block';
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'See My Results';
          }
        }
      } catch (error) {
        console.error('Error submitting contact form:', error);
        if (errorMessage) {
          errorMessage.textContent = 'An error occurred. Please try again.';
          errorMessage.style.display = 'block';
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'See My Results';
        }
      }
    });
  }

  // Helper: extract product URLs from recommendations (same shape as displayRecommendations used)
  function getProductUrlsFromRecommendations(recommendations) {
    let products = [];
    if (Array.isArray(recommendations)) {
      products = recommendations;
    } else if (recommendations && recommendations.products && Array.isArray(recommendations.products)) {
      products = recommendations.products;
    } else if (recommendations && recommendations.data && Array.isArray(recommendations.data)) {
      products = recommendations.data;
    }
    const productUrls = [];
    if (products && products.length > 0) {
      products.forEach((product) => {
        const productUrl = product.url || product.handle || '';
        if (productUrl && productUrl !== '#') {
          productUrls.push(productUrl);
        }
      });
    }
    return productUrls;
  }

  // Redirect to product page with result param (form is now on product page)
  function redirectToProductWithResult(recommendations, data) {
    const productUrls = getProductUrlsFromRecommendations(recommendations);
    const sessionToken = data.session_token || (data.data && data.data.session_token);
    const tokenForResult = sessionToken || localStorage.getItem('session_token');

    if (!tokenForResult) {
      quizApiSection.innerHTML = `
        <div class="error-message">
          <strong>Session expired.</strong> Please restart the quiz.
          <br><br>
          <button onclick="location.reload()">Retry</button>
        </div>
      `;
      return;
    }

    if (productUrls.length === 0) {
      quizApiSection.innerHTML = `
        <div class="error-message">
          <strong>No product recommendation available.</strong> Please try again.
          <br><br>
          <button onclick="location.reload()">Retry</button>
        </div>
      `;
      return;
    }

    let finalUrl = productUrls[0];
    if (!finalUrl.startsWith('http://') && !finalUrl.startsWith('https://')) {
      if (finalUrl.startsWith('/')) {
        finalUrl = window.location.origin + finalUrl;
      } else {
        const cleanHandle = finalUrl.replace(/^\/+|\/+$/g, '');
        if (cleanHandle && !cleanHandle.includes('/')) {
          finalUrl = window.location.origin + '/products/' + cleanHandle;
        } else {
          finalUrl = window.location.origin + '/' + cleanHandle;
        }
      }
    }
    const urlObj = new URL(finalUrl);
    urlObj.searchParams.set('result', tokenForResult);
    window.location.href = urlObj.toString();
  }

  // Function to submit quiz with file upload
  async function submitQuizWithFile(questionId, file, skipPhoto = false) {
    if (isApiCallInProgress) {
      return;
    }

    const sessionToken = localStorage.getItem('session_token');

    if (!sessionToken) {
      alert('Session expired. Please restart the quiz.');
      return;
    }

    isApiCallInProgress = true;

    try {
      // Show loading state
      quizApiSection.innerHTML = '<div class="dot-loader"></div>';

      const apiUrl = 'https://quiz.miiroko.com/api/v1/quiz/start';
      const shopDomain = getShopDomain();

      // Create FormData with required fields
      const formData = new FormData();
      formData.append('session_token', sessionToken);
      formData.append('question_id', questionId);
      formData.append('shop', shopDomain);

      // Add answer_ids[] - only send if there are actual answers
      // For file upload questions, there are no answers, so we don't send this field
      const form = document.getElementById('custom-quiz-form');
      let answerIds = [];
      if (form) {
        const checkedInputs = form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
        answerIds = Array.from(checkedInputs).map(input => input.value);
      }

      // Only send answer_ids[] if there are actual answers
      // For file upload questions, we don't send answer_ids[] at all
      if (answerIds.length > 0) {
        answerIds.forEach(id => {
          formData.append('answer_ids[]', id);
        });
      }
      // Note: We don't send answer_ids[] for file upload questions as they have no answers

      // Add file if provided (as hair_photo)
      if (file) {
        formData.append('hair_photo', file);
      } else if (skipPhoto) {
        // If skip button was clicked, send skip_photo = true
        formData.append('skip_photo', 'true');
      }

      // Log what we're sending
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
        mode: 'cors',
        credentials: 'omit'
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => 'Unknown error');
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();
      
      // Update progress bar
      updateProgressBar(data);

      // Update session token if provided
      const newSessionToken = data.session_token || (data.data && data.data.session_token);
      if (newSessionToken) {
        localStorage.setItem('session_token', newSessionToken);
        
      }

      // Check for recommendations in various possible locations
      let recommendations = null;
      if (data.recommendations) {
        recommendations = data.recommendations;
      } else if (data.data && data.data.recommendations) {
        recommendations = data.data.recommendations;
      } else if (data.products) {
        recommendations = data.products;
      } else if (data.data && data.data.products) {
        recommendations = data.data.products;
      } else if (data.result) {
        recommendations = data.result;
      } else if (data.data && data.data.result) {
        recommendations = data.data.result;
      }
      const hasRecommendations = recommendations && (Array.isArray(recommendations) ? recommendations.length > 0 : true);

      // Quiz is complete when API says so OR when we have recommendations (completion UI)
      const isCompleted = isQuizCompleteFromResponse(data, hasRecommendations);

      // Clear question history and current question state/data when quiz is completed
      if (isCompleted) {
        clearQuestionHistory();
        clearCurrentQuestionState();
        clearCurrentQuestionData();
        setQuizCompletedTimestamp(); // Session token will be cleared 30 min after this
      }
      // Redirect to product page with result param (contact form is on product page)
      if (recommendations) {
        redirectToProductWithResult(recommendations, data);
      } else {
        quizApiSection.innerHTML = `
          <div class="error-message">
            ${isCompleted ? '<p>Your recommendations will be available shortly.</p>' : ''}
            <strong>No product recommendation available.</strong> Please try again.
            <br><br>
            <button onclick="location.reload()">Retry</button>
          </div>
        `;
      }

    } catch (error) {
      console.error('Error submitting quiz with file:', error);
      quizApiSection.innerHTML = `
        <div class="error-message">
          <strong>Error submitting quiz:</strong><br>
          ${error.message}
          <br><br>
          <button onclick="location.reload()">Retry</button>
        </div>
      `;
    } finally {
      isApiCallInProgress = false;
    }
  }

  async function submitQuiz(questionId) {
    if (isApiCallInProgress) {
      return;
    }

    const form = document.getElementById('custom-quiz-form');
    if (!form) {
      console.error('Quiz form not found');
      return;
    }

    // Get selected answers
    const checkedInputs = form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

    if (checkedInputs.length === 0) {
      showQuestionError('Please select at least one answer before submitting.');
      return;
    }

    // Clear any existing error message since we have a valid selection
    clearQuestionError();

    const answerIds = Array.from(checkedInputs).map(input => input.value);
    const sessionToken = localStorage.getItem('session_token');

    if (!sessionToken) {
      alert('Session expired. Please restart the quiz.');
      return;
    }

    isApiCallInProgress = true;

    try {
      // Show loading state
      quizApiSection.innerHTML = '<div class="dot-loader"></div>';

      const apiUrl = 'https://quiz.miiroko.com/api/v1/quiz/start';
      const shopDomain = getShopDomain();

      // Create FormData with required fields
      const formData = new FormData();
      formData.append('session_token', sessionToken);
      formData.append('question_id', questionId);
      formData.append('shop', shopDomain);
      answerIds.forEach(id => {
        formData.append('answer_ids[]', id);
      });

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
        mode: 'cors',
        credentials: 'omit'
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => 'Unknown error');
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();

      // Update progress bar
      updateProgressBar(data);

      // Quiz completed (submit is last step) – session token will be cleared 30 min after this
      setQuizCompletedTimestamp();

      // Check for recommendations in various possible locations
      let recommendations = null;
      if (data.recommendations) {
        recommendations = data.recommendations;
      } else if (data.data && data.data.recommendations) {
        recommendations = data.data.recommendations;
      } else if (data.products) {
        recommendations = data.products;
      } else if (data.data && data.data.products) {
        recommendations = data.data.products;
      } else if (data.result) {
        recommendations = data.result;
      } else if (data.data && data.data.result) {
        recommendations = data.data.result;
      }

      // Redirect to product page with result param (contact form is on product page)
      if (recommendations) {
        redirectToProductWithResult(recommendations, data);
      } else {
        quizApiSection.innerHTML = `
          <div class="error-message">
            <strong>No product recommendation available.</strong> Please try again.
            <br><br>
            <button onclick="location.reload()">Retry</button>
          </div>
        `;
      }

    } catch (error) {
      console.error('Error submitting quiz:', error);
      quizApiSection.innerHTML = `
        <div class="error-message">
          <strong>Error submitting quiz:</strong><br>
          ${error.message}
          <br><br>
          <button onclick="location.reload()">Retry</button>
        </div>
      `;
    } finally {
      isApiCallInProgress = false;
    }
  }

  // Function to start quiz
  async function startQuiz() {
    if (isApiCallInProgress) {
      return;
    }

    // Clear session_token if 30 minutes have passed since quiz was completed
    clearSessionIfExpired();

    // Check if we have an existing session_token to resume
    const existingSessionToken = localStorage.getItem('session_token');
    const isResuming = !!existingSessionToken;

    // Only reset question history when starting a completely new quiz
    if (!isResuming) {
      questionHistory = [];
      currentQuestionData = null;
      clearQuestionHistory(); // Clear from localStorage too
    } else {
      // When resuming, load question history from localStorage
      loadQuestionHistory();
    }

    // Clear any existing content in the quiz section
    if (quizApiSection) {
      quizApiSection.innerHTML = '';
    }

    isApiCallInProgress = true;

    try {
      // Show loading state
      if (quizApiSection) {
        quizApiSection.innerHTML = '<div class="dot-loader"></div>';
      }

      const apiUrl = 'https://quiz.miiroko.com/api/v1/quiz/start';
      const shopDomain = getShopDomain();

      // Create FormData to send shop (using full domain)
      const formData = new FormData();
      formData.append('shop', shopDomain);

      // If we have an existing session_token, send it to resume the quiz
      if (isResuming && existingSessionToken) {
        formData.append('session_token', existingSessionToken);
      }

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
        mode: 'cors',
        credentials: 'omit'
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => 'Unknown error');
        let errorMessage = `HTTP error! status: ${response.status}`;

        // Try to parse error message
        try {
          const errorData = JSON.parse(errorText);
          if (errorData.message) {
            errorMessage = errorData.message;
          }
          if (errorData.data && errorData.data.error) {
            errorMessage = errorData.data.error;
          }
        } catch (e) {
          errorMessage = errorText;
        }

        console.error('API Error Response:', {
          status: response.status,
          statusText: response.statusText,
          body: errorText,
          shopDomain: shopDomain,
          isResuming: isResuming
        });

        // If we were trying to resume and got a 401/404 (session expired/invalid), 
        // clear the session_token and retry as a new quiz
        if (isResuming && (response.status === 401 || response.status === 404)) {
          localStorage.removeItem('session_token');
          questionHistory = [];
          currentQuestionData = null;

          // Retry as a new quiz
          isApiCallInProgress = false;
          return startQuiz();
        }

        throw new Error(errorMessage);
      }

      const data = await response.json();

      // Store session_token in localStorage (check multiple possible locations)
      const sessionToken = data.session_token || (data.data && data.data.session_token);
      if (sessionToken) {
        localStorage.setItem('session_token', sessionToken);
      }

      // Display question
      currentQuestionData = data;

      // Extract data structure properly
      let questionData = data;
      if (data.data && data.data.question) {
        questionData = { ...data.data.question, answers: data.data.answers || data.data.question.answers || [] };
      } else if (data.data && (data.data.question || data.data.answers)) {
        questionData = data.data;
      }

      const rawIsLastQuestion = data.is_last || questionData.is_last || (data.data && data.data.is_last) || false;
      const templateType = (data.template_type || questionData.template_type || (data.data && data.data.template_type) || 'buttons');
      const questionType = (data.question_type || questionData.question_type || (data.data && data.data.question_type) || 'single_choice');
      const isFileTemplate = templateType === 'file';

      // Determine if this is the first question
      // If resuming, check if we have any history or if the API indicates it's the first question
      // If starting new, it's always the first question
      let isFirstQuestion = false;
      if (!isResuming) {
        // Starting a new quiz - always first question
        isFirstQuestion = true;
        // Force isLastQuestion to false for first question of new quiz
        const isLastQuestionForFirst = false;
        const questionHTML = formatQuestionHTML(data, isLastQuestionForFirst, isFirstQuestion);

        // Set HTML and attach listeners
        if (quizApiSection) {
          // Seed estimated total from first question progress so progress bar is correct if user goes back later
          const firstApiPct = getProgressPercentageFromData(data);
          if (firstApiPct != null && firstApiPct > 0 && firstApiPct <= 100) {
            const estimated = Math.round(100 / firstApiPct);
            if (estimated >= 2 && estimated <= 200) estimatedTotalQuestions = estimated;
          }
          quizApiSection.innerHTML = questionHTML;
          saveCurrentQuestionData(data);
          requestAnimationFrame(() => {
            attachEventListeners(data);
            // Explicitly enforce button visibility for first question of new quiz
            const nextBtn = document.querySelector('.btn-next');
            const submitBtn = document.querySelector('.btn-submit');
            const prevBtn = document.querySelector('.btn-prev');

            // Show Next button for slider templates OR multiple_choice questions, otherwise hide it (auto-proceed handles navigation)
            if (nextBtn) {
              nextBtn.style.display = ((templateType === 'slider' || questionType === 'multiple_choice') && !isLastQuestionForFirst) ? 'inline-block' : 'none';
            }
            if (submitBtn) {
              submitBtn.style.display = 'none';
            }
            if (prevBtn) {
              prevBtn.style.display = 'none';
            }

            // Reset progress bar to 0% for first question of new quiz
            const progressBar = document.querySelector('.progress-bar .progress');
            if (progressBar) {
              progressBar.style.width = '0%';
            }

            // Update progress bar AFTER the form is rendered (only if progress data exists)
            const progressPercentage = data.progress?.percentage || data.data?.progress?.percentage || data.progress || data.data?.progress;
            if (progressPercentage !== undefined && progressPercentage !== null && progressPercentage > 0 && progressPercentage < 100) {
              updateProgressBar(data);
            }
          });
        }
      } else {
        // Resuming quiz - determine if first question based on loaded question history
        // If questionHistory is empty, this is the first question
        // If questionHistory has items, this is not the first question
        isFirstQuestion = questionHistory.length === 0;

        // Use the actual isLastQuestion from API when resuming
        const isLastQuestionForResume = rawIsLastQuestion || isFileTemplate;

        
        const questionHTML = formatQuestionHTML(data, isLastQuestionForResume, isFirstQuestion);
        
        // Set HTML and attach listeners
        if (quizApiSection) {
          quizApiSection.innerHTML = questionHTML;
          saveCurrentQuestionData(data);
          requestAnimationFrame(() => {
            attachEventListeners(data);

            // For resumed quiz, show Previous button when we have question history (scope to quiz section)
            const nextBtn = quizApiSection.querySelector('.btn-next');
            const submitBtn = quizApiSection.querySelector('.btn-submit');
            const prevBtn = quizApiSection.querySelector('.btn-prev');

            const hasHistory = questionHistory.length > 0;
            if (prevBtn) {
              prevBtn.style.display = hasHistory ? 'inline-block' : 'none';
            }
            // Show Next button for slider templates OR multiple_choice questions, otherwise hide it (auto-proceed handles navigation)
            if (nextBtn) {
              nextBtn.style.display = ((templateType === 'slider' || questionType === 'multiple_choice') && !isLastQuestionForResume) ? 'inline-block' : 'none';
            }
            if (submitBtn) {
              submitBtn.style.display = isLastQuestionForResume ? 'inline-block' : 'none';
            }

            // Restore previously selected answers for this question (after refresh + Continue Quiz)
            const currentQuestionId = (data.id || (data.data && data.data.id) || questionData.id || '').toString();
            const savedState = loadCurrentQuestionState();
            if (savedState && savedState.questionId === currentQuestionId && savedState.answerIds && savedState.answerIds.length > 0) {
              const resumeForm = document.getElementById('custom-quiz-form');
              if (resumeForm) {
                resumeForm.setAttribute('data-restoring-answers', 'true');
                savedState.answerIds.forEach(answerId => {
                  const input = resumeForm.querySelector(`input[value="${answerId.replace(/"/g, '\\"')}"]`);
                  if (input) {
                    input.checked = true;
                    input.dispatchEvent(new Event('change'));
                  }
                });
                setTimeout(() => {
                  if (resumeForm) resumeForm.removeAttribute('data-restoring-answers');
                }, 100);
                // Re-apply Previous button visibility after restore (in case any handler affected it)
                const prevAfterRestore = quizApiSection.querySelector('.btn-prev');
                if (prevAfterRestore) prevAfterRestore.style.display = hasHistory ? 'inline-block' : 'none';
              }
            }

            // Update progress bar with actual progress from API
            updateProgressBar(data);
          });
        }
      }

    } catch (error) {
      console.error('Error starting quiz:', error);
      const shopDomain = getShopDomain();
      quizApiSection.innerHTML = `
        <div class="error-message">
          <strong>Error loading quiz:</strong><br>
          ${error.message}
          <br><br>
          <small class="debug-info">
            <strong>Debug Info:</strong><br>
            Shop domain sent to API: <code>${shopDomain}</code><br>
            <br>
            <strong>Possible solutions:</strong><br>
            1. Verify the shop domain is correct: <code>${shopDomain}</code><br>
            2. Ensure the API has active questions configured for this shop<br>
            3. Check if the API server is running and accessible<br>
            4. Verify CORS settings on the API server allow requests from your Shopify domain<br>
            5. Check browser console for more details
          </small>
        </div>
      `;
    } finally {
      isApiCallInProgress = false;
    }
  }

  // Listen for click on quiz button
  quizBtn.addEventListener('click', async function (e) {
    await startQuiz();
  }, true);

  // Also listen for modal open event as a backup
  if (modal) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (modal.hasAttribute('open')) {
            const sessionToken = localStorage.getItem('session_token');
            if (!sessionToken && quizApiSection.innerHTML.trim() === '' && !isApiCallInProgress) {
              startQuiz();
            }
          }
        }
      });
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  // Restore quiz from saved state (no API call, no loading) – used when "Continue Quiz" after refresh
  function restoreFromSavedQuiz() {
    // Load history from localStorage and sync global – this is the source of truth for "do we have a previous question?"
    let savedHistoryArray = [];
    try {
      const raw = localStorage.getItem('quiz_question_history');
      if (raw) {
        const parsed = JSON.parse(raw);
        savedHistoryArray = Array.isArray(parsed) ? parsed : [];
      }
    } catch (e) { /* leave empty */ }
    questionHistory = savedHistoryArray;
    const historyLength = questionHistory.length;
    const hasHistory = historyLength > 0;
    const isFirstQuestion = historyLength === 0;

    const data = loadCurrentQuestionData();
    if (!data) {
      startQuiz();
      return;
    }
    currentQuestionData = data;
    let questionData = data;
    if (data.data && data.data.question) {
      questionData = { ...data.data.question, answers: data.data.answers || data.data.question.answers || [] };
    } else if (data.data && (data.data.question || data.data.answers)) {
      questionData = data.data;
    }
    const templateType = data.template_type || questionData.template_type || (data.data && data.data.template_type) || 'buttons';
    const questionType = data.question_type || questionData.question_type || (data.data && data.data.question_type) || 'single_choice';
    const isFileTemplate = templateType === 'file';
    const rawIsLast = data.is_last || questionData.is_last || (data.data && data.data.is_last);
    const isLastQuestionForResume = isFileTemplate || (rawIsLast === true || rawIsLast === 'true');
    // If user has history they are not on first question: always show Previous, never show Submit (they continue via Next or auto-proceed)
    const showPrev = hasHistory;
    const showSubmit = hasHistory ? false : isLastQuestionForResume;

    const questionHTML = formatQuestionHTML(data, showSubmit, isFirstQuestion);
    quizApiSection.innerHTML = questionHTML;
    attachEventListeners(data);

    const nextBtn = quizApiSection.querySelector('.btn-next');
    const submitBtn = quizApiSection.querySelector('.btn-submit');
    const prevBtn = quizApiSection.querySelector('.btn-prev');
    if (prevBtn) prevBtn.style.display = showPrev ? 'inline-block' : 'none';
    if (submitBtn) submitBtn.style.display = showSubmit ? 'inline-block' : 'none';
    if (nextBtn) nextBtn.style.display = ((templateType === 'slider' || questionType === 'multiple_choice') && !showSubmit) ? 'inline-block' : 'none';

    const currentQuestionId = (data.id || (data.data && data.data.id) || questionData.id || '').toString();
    const savedState = loadCurrentQuestionState();
    if (savedState && savedState.questionId === currentQuestionId && savedState.answerIds && savedState.answerIds.length > 0) {
      const resumeForm = document.getElementById('custom-quiz-form');
      if (resumeForm) {
        resumeForm.setAttribute('data-restoring-answers', 'true');
        savedState.answerIds.forEach(answerId => {
          const input = resumeForm.querySelector(`input[value="${answerId.replace(/"/g, '\\"')}"]`);
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change'));
          }
        });
        setTimeout(() => {
          if (resumeForm) resumeForm.removeAttribute('data-restoring-answers');
          applyRestoreButtonVisibility();
        }, 100);
      }
    } else {
      setTimeout(applyRestoreButtonVisibility, 50);
    }

    function applyRestoreButtonVisibility() {
      const histLen = questionHistory.length;
      const showP = histLen > 0;
      const showS = histLen > 0 ? false : (isFileTemplate || (rawIsLast === true || rawIsLast === 'true'));
      const pBtn = quizApiSection.querySelector('.btn-prev');
      const sBtn = quizApiSection.querySelector('.btn-submit');
      const nBtn = quizApiSection.querySelector('.btn-next');
      if (pBtn) pBtn.style.display = showP ? 'inline-block' : 'none';
      if (sBtn) sBtn.style.display = showS ? 'inline-block' : 'none';
      if (nBtn) nBtn.style.display = ((templateType === 'slider' || questionType === 'multiple_choice') && !showS) ? 'inline-block' : 'none';
    }
    setTimeout(applyRestoreButtonVisibility, 250);

    // Only update progress when saved value is < 100% (API often sends 100% for last question before submit).
    // Defer update so the modal's progress bar is in the DOM and laid out (fixes refresh-then-Continue case).
    let savedPercentage = null;
    if (data.progress && data.progress.percentage !== undefined) {
      savedPercentage = data.progress.percentage;
    } else if (data.data && data.data.progress && data.data.progress.percentage !== undefined) {
      savedPercentage = data.data.progress.percentage;
    } else if (data.progress !== undefined) {
      savedPercentage = data.progress;
    } else if (data.data && data.data.progress !== undefined) {
      savedPercentage = data.data.progress;
    }
    const shouldUpdateProgress = savedPercentage !== null && savedPercentage !== undefined && Number(savedPercentage) < 100;
    const progressData = data;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (shouldUpdateProgress) {
          updateProgressBar(progressData);
        }
      });
    });
  }

  // Quiz quit modal: popup appears when modal close (X) is clicked or when page is refreshed with active session.
  // Page is refreshed ONLY when quiz-quit-btn is clicked; otherwise no refresh (Continue / X close = no reload).
  const quizQuitModal = document.getElementById('quiz-quit-modal');
  const modalCloseBtn = modal ? modal.querySelector('.modal__close-btn') : null;
  const quizQuitBtn = quizQuitModal ? quizQuitModal.querySelector('.quiz-quit-btn') : null;
  const quizStayBtn = quizQuitModal ? quizQuitModal.querySelector('.quiz-stay-btn') : null;

  function openQuitModal() {
    if (quizQuitModal) {
      quizQuitModal.classList.add('active');
      quizQuitModal.setAttribute('aria-hidden', 'false');
    }
  }

  function closeQuitModal() {
    if (quizQuitModal) {
      quizQuitModal.classList.remove('active');
      quizQuitModal.setAttribute('aria-hidden', 'true');
    }
  }

  // When modal close button (X) is clicked: show quit confirmation only (no refresh)
  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openQuitModal();
    }, true);
  }

  // When page is refreshed with active quiz session: show popup (and open main modal). No refresh here.
  clearSessionIfExpired();
  if (localStorage.getItem('session_token')) {
    if (modal) {
      if (typeof modal.open === 'function') {
        modal.open(null);
      } else {
        modal.setAttribute('open', '');
      }
    }
    openQuitModal();
  }

  // When user returns to this tab, re-check expiry so session is cleared even without a full page reload
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    clearSessionIfExpired();
    if (!localStorage.getItem('session_token')) {
      closeQuitModal();
      if (modal) {
        if (modal.removeAttribute) modal.removeAttribute('open');
      }
    }
  });

  // Only place we refresh: when user explicitly clicks "Quit Quiz"
  if (quizQuitBtn) {
    quizQuitBtn.addEventListener('click', function () {
      localStorage.removeItem('session_token');
      localStorage.removeItem(QUIZ_COMPLETED_AT_KEY);
      clearQuestionHistory();
      clearCurrentQuestionState();
      clearCurrentQuestionData();
      closeQuitModal();
      window.location.reload();
    });
  }

  // Continue quiz: close popup, keep modal open, restore same question from saved state (no API, no re-render flash). No refresh.
  if (quizStayBtn) {
    quizStayBtn.addEventListener('click', function () {
      closeQuitModal();
      if (modal) {
        if (typeof modal.open === 'function') {
          modal.open(null);
        } else {
          modal.setAttribute('open', '');
        }
        restoreFromSavedQuiz();
      }
    });
  }
});